import React, { Fragment, useEffect, useRef, useState } from 'react'
import Sidebar from './Sidebar'

// icons start 
import { RiEditLine } from "react-icons/ri";
import { MdDeleteForever } from "react-icons/md";
import { FaStar } from "react-icons/fa6";
import { HiDocumentReport } from "react-icons/hi";
import { IoIosRemoveCircle } from "react-icons/io";
import { MdEditDocument } from "react-icons/md";
// icons end

import Logo_school from "../assets/Logo_school.png"


import axios from 'axios';
import { API } from './constant';
import Select from "react-select";


// export excel sta
import { DownloadTableExcel } from 'react-export-table-to-excel';
// export excel end
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import "./global.css"


const Students = () => {

    const tableRef = useRef(null);

    const [updateTable, setupdateTable] = useState(false)





    // get all students start 
    const [getAllStudentData, setgetAllStudentData] = useState([])
    // console.log(getAllStudentData)
    useEffect(() => {
        axios.get(`${API}/students-upload`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setgetAllStudentData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // get all students END 



    // fetch logged in user data start 
    const [userData, setuserData] = useState([])
    // console.log(userData)
    // console.log(userData)
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data)
                setuserData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // fetch logged in user data end



    //==================== operation on assess modal start ======================
    // fetch all session data start 
    const [allSessionData, setallSessionData] = useState([])
    useEffect(() => {
        axios.get(`${API}/session`)
            .then((res) => {
                // console.log(res)
                setallSessionData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // fetch all session data end


    // get all months data start
    const [allMonthsData, setallMonthsData] = useState([])
    useEffect(() => {
        axios.get(`${API}/months`)
            .then((res) => {
                // console.log(res)
                setallMonthsData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // get all months data end



    // fetch rubric type start 
    const [rubricTypeAllData, setrubricTypeAllData] = useState([])

    useEffect(() => {
        axios.get(`${API}/rubric-type`)
            .then((res) => {
                // console.log(res)
                setrubricTypeAllData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // fetch rubric type end


    // --------------get all class data start ----------
    const [allClassDATA, setallClassDATA] = useState([])
    useEffect(() => {
        axios.get(`${API}/create-class`)
            .then((res) => {
                // console.log(res)
                setallClassDATA(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    // --------------get all class data end ----------


    //------------ get section start ----------------
    const [get_section, setget_section] = useState([])
    // console.log(get_section)
    useEffect(() => {
        axios.get(`${API}/create-section`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setget_section(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //------------ get section end ----------------

    const [selectedClass, setSelectedClass] = useState('');
    const [sections, setSections] = useState([]);
    // console.log(sections)
    useEffect(() => {
        axios
            .get(`${API}/create-section/permitted-to-logged-in-user`, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token'),
                },
            })
            .then((res) => {
                setget_section(res.data.data); // Store fetched data
                // Optionally set default class if needed
                // if (res.data.data.length > 0) {
                //     setSelectedClass(res.data.data[0].class_name); // Set first class as default
                // }
            })
            .catch((err) => {
                console.error('Error fetching sections:', err);
            });
    }, [updateTable]); // Re-fetch when updateTable changes

    // Update sections when selectedClass changes
    useEffect(() => {
        if (selectedClass) {
            const selectedClassData = get_section.find(
                (item) => item.class_name === selectedClass
            );
            setSections(selectedClassData ? selectedClassData.sections : []);
        } else {
            setSections([]);
        }
    }, [selectedClass, get_section]);

    // Handle class selection
    const handleClassChange = (e) => {
        setSelectedClass(e.target.value);
    };



    // fetch all rubric skills start 
    const [rubricSkillsAllData, setrubricSkillsAllData] = useState([])
    useEffect(() => {
        axios.get(`${API}/rubric-skills`)
            .then((res) => {
                // console.log(res)
                setrubricSkillsAllData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // fetch all rubric skills end


    // get all judge criteria start 
    const [getAllJudgeCriteria, setgetAllJudgeCriteria] = useState([])
    useEffect(() => {
        axios.get(`${API}/judge-criteria`)
            .then((res) => {
                // console.log(res)
                setgetAllJudgeCriteria(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // get all judge criteria end





    // operation on modal start 
    const [assessModal, setassessModal] = useState(false)
    const [assessdModalId, setassessdModalId] = useState("")
    const [selectedRow, setselectedRow] = useState([])

    const [studentID, setstudentID] = useState("")
    const [studentName, setstudentName] = useState("")
    const [class_name, setclass_name] = useState("")
    const [sessionName, setsessionName] = useState("")
    const [month_name, setmonth_name] = useState("")
    const [rubric_type_skills, setrubric_type_skills] = useState("")
    const [rubricSkills, setrubricSkills] =
        useState([
            {
                skill_name: "",
                skill_answer: "",
                updated_on: "",
                rubric_month: "",
                rubric_session: ""
            }])
    const [comments, setcomments] = useState("")
    const [suggestionForParents, setsuggestionForParents] = useState("")
    const [reference_url, setreference_url] = useState("")
    const [star, setstar] = useState(0)
    const stars = [
        {
            val: 1,
        },
        {
            val: 2,
        },
        {
            val: 3,
        }
    ]

    const [showPreviewModal, setshowPreviewModal] = useState(false)

    const handleFillStar = (val) => {
        setstar(val);
    };

    const [fetchedSession, setfetchedSession] = useState("")
    const [fetchedAssessmentPeriod, setfetchedAssessmentPeriod] = useState("")

    useEffect(() => {
        axios.get((`${API}/default-session/689ada445027a6bbae0adf3a`))
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetchedSession(res.data.data.default_session)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    useEffect(() => {
        axios.get((`${API}/default-assessment-period/689ad9de5027a6bbae0adf38`))
            .then((res) => {
                // console.log(res.data.data.default_month)
                setfetchedAssessmentPeriod(res.data.data.default_month)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    // console.log(assessModal)
    // console.log(assessdModalId)


    const handleAsssess = (id) => {
        try {
            // console.log("we are handling assess")
            setassessModal(true)
            setassessdModalId(id)
            axios.get(`${API}/students-upload/${id}`)
                .then((res) => {
                    console.log(res.data.data)
                    setselectedRow(res.data.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        } catch (error) {
            console.log(error)
        }
    }


    const [skillAnswers, setSkillAnswers] = useState({});

    // Handle dropdown change for skill_answer
    const handleSkillAnswerChange = (skillName, selectedAnswer) => {
        setSkillAnswers((prev) => ({
            ...prev,
            [skillName]: selectedAnswer,
        }));
    };


    const handleSaveStudentData = async (id) => {
        try {
            // Filter rubricSkillsAllData based on current filters
            const filteredSkills = rubricSkillsAllData.filter((item) => {
                if (!selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                    return true;
                }
                if (selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                    return item.class_name === selectedRow.classes;
                }
                if (!selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                    return item.month_name === fetchedAssessmentPeriod;
                }
                if (!selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                    return item.rubric_type === rubric_type_skills;
                }
                if (selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                    return item.class_name === selectedRow.classes && item.month_name === fetchedAssessmentPeriod;
                }
                if (selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                    return item.class_name === selectedRow.classes && item.rubric_type === rubric_type_skills;
                }
                if (!selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                    return item.month_name === fetchedAssessmentPeriod && item.rubric_type === rubric_type_skills;
                }
                if (selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                    return (
                        item.class_name === selectedRow.classes &&
                        item.month_name === fetchedAssessmentPeriod &&
                        item.rubric_type === rubric_type_skills
                    );
                }
                return false;
            });

            // Prepare rubric_skills array from filtered skills and selected answers
            const rubric_skills = filteredSkills.map((item) => ({
                skill_name: item.skill_name,
                skill_answer: skillAnswers[item.skill_name] || "", // Use selected answer or empty string
                rubric_month: fetchedAssessmentPeriod,
                rubric_session: fetchedSession,
            }));

            // Validate that all skills have answers
            const hasEmptyAnswers = rubric_skills.some((skill) => !skill.skill_answer);
            if (hasEmptyAnswers) {
                alert("Please select progress for all skills before saving.");
                return;
            }

            const data = {
                teacher_name: userData._id,
                rubric_type: rubric_type_skills,
                rubric_skills, // Send array of skills
                comments: comments,
                parents_suggestion: suggestionForParents,
                reference_url: reference_url,
                star: star
            };

            const response = await axios.put(`${API}/students-upload/student-assess/${id}`, data, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            });
            // console.log("Success:", response.data);
            alert(`Student assessed for ${month_name} successfully!`);
            clearFields()
            setassessModal(false)
            setSkillAnswers({})       // clear selected answers

            setupdateTable(!updateTable)
        } catch (err) {
            console.error("Error:", err.response?.data || err.message);
            alert(err.response.data.message);
        }
    };


    const handleAssessModalClose = () => {
        setassessModal(false)
        setassessdModalId("")
        clearFields()
    }
    // operation on modal end



    //==================== operation on assess modal end ======================


    const clearFields = () => {
        setsessionName("")
        setmonth_name("")
        setrubric_type_skills("")
        setcomments("")
        setsuggestionForParents("")
        setstar(0)
    }


    // ===================operation on filter students start ====================
    const [searchName, setSearchName] = useState('');
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [selectedSession, setSelectedSession] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedSection, setSelectedSection] = useState('');

    useEffect(() => {
        const filterStudents = () => {
            let filtered = getAllStudentData;
            // console.log(filtered)

            // 🔹 Decide session based on role
            const sessionToUse =
                userData.role === "Super Admin" ? selectedSession : fetchedSession;


            // Filter by name (case-insensitive partial match)
            if (searchName) {
                filtered = filtered.filter((student) =>
                    (student.name || "").toLowerCase().includes(searchName.toLowerCase())
                );
            }

            // Filter by class
            if (selectedClass) {
                filtered = filtered.filter((student) => student.classes === selectedClass);
            }

            // Filter by section
            if (selectedSection) {
                filtered = filtered.filter((student) => student.section === selectedSection);
            }

            // ✅ FIXED session filter
            if (sessionToUse) {
                filtered = filtered.filter(
                    (student) => student.session === sessionToUse
                );
            }


            // Filter by month (check rubric_data)
            if (selectedMonth) {
                filtered = filtered.filter((student) =>
                    student.rubric_data.some((rubric) => rubric.month === selectedMonth)
                );
            }

            setFilteredStudents(filtered);
        };

        filterStudents();
    }, [searchName, selectedClass,
        selectedSection, selectedSession,
        selectedMonth, getAllStudentData,
        fetchedSession, // 🔥 IMPORTANT
        userData.role   // 🔥 IMPORTANT
    ]);
    // console.log(filteredStudents)
    // Handle input changes

    const handleSectionChange = (e) => {
        setSelectedSection(e.target.value);
    };
    // console.log(userData)
    const handleSessionChange = (e) => {
        // console.log("Selected:", e.target.value);
        setSelectedSession(e.target.value);
    };
    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    const handleNameChange = (e) => {
        setSearchName(e.target.value);
    };
    // ===================operation on filter students end ====================

    // ======================== Operation for Emailing Report Card start ===============
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [showEmailModal, setshowEmailModal] = useState(false);
    const [emailContent, setEmailContent] = useState("");
    const [emailMonth, setEmailMonth] = useState("");
    // const [emailRubricType, setEmailRubricType] = useState("");
    const [emailRubricType, setEmailRubricType] = useState([]);
    const [emailing, setEmailing] = useState(false);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Select all currently filtered students
            const allIds = filteredStudents.map(s => s._id);
            setSelectedStudents(allIds);
        } else {
            setSelectedStudents([]);
        }
    };

    const handleSelectStudent = (id) => {
        if (selectedStudents.includes(id)) {
            setSelectedStudents(selectedStudents.filter(sId => sId !== id));
        } else {
            setSelectedStudents([...selectedStudents, id]);
        }
    };

    const handleSendEmails = async () => {
        if (selectedStudents.length === 0) {
            alert("No students selected!");
            return;
        }
        if (!emailMonth || !emailRubricType || !emailContent) {
            alert("Please fill in email content, month, and rubric type.");
            return;
        }

        setEmailing(true);
        let successCount = 0;
        let failCount = 0;

        for (const studentId of selectedStudents) {
            try {
                const response = await axios.post(`${API}/report-card/send-email`, {
                    student_id: studentId,
                    email_content: emailContent,
                    rubric_month: emailMonth,
                    // rubric_type: emailRubricType
                    rubric_type: emailRubricType.map(item => item.value)
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "token": localStorage.getItem("token")
                    }
                });
                if (response.status === 200) successCount++;
            } catch (error) {
                console.error(`Failed to send email to student ${studentId}:`, error);
                failCount++;
            }
        }

        setEmailing(false);
        alert(`Finished sending emails. Success: ${successCount}, Failed: ${failCount}`);
        if (failCount === 0) {
            setshowEmailModal(false);
            setEmailContent("");
            setEmailMonth("");
            setEmailRubricType("");
            setSelectedStudents([]);
        }
    };
    // ======================== Operation for Emailing Report Card end ===============

    // ======================== Operation on update student that will access later start===============
    const [updateModal, setupdateModal] = useState(false)
    const [updateStudentDataId, setupdateStudentDataId] = useState("")
    const [updateStudentName, setupdateStudentName] = useState("")
    const [updateAllData, setupdateAllData] = useState([])
    const [updateStudentMonth, setupdateStudentMonth] = useState("")
    const [updateStudentRubricType, setupdateStudentRubricType] = useState("")
    const [filteredUpdateRubricData, setFilteredUpdateRubricData] = useState([])
    const [skillChanges, setSkillChanges] = useState({});
    const [parentsSuggestion, setParentsSuggestion] = useState('');
    const [referenceUrl, setReferenceUrl] = useState('');
    const [updatestarRating, setupdatestarRating] = useState(0);

    // console.log(updatestarRating)
    // Format: { "691d86951773ab8cf7c8ffe7": "ACHIEVED", "691d86951773ab8cf7c8ffe8": "EMERGING" }

    const openUpdateModal = async (id) => {
        setupdateModal(true)
        setupdateStudentDataId(id)

        try {
            const response = await axios.get(`${API}/report-card/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token'),
                },
            });
            // console.log('API Response:', response.data); // Debug log
            setupdateAllData(response.data);
            setupdateStudentName(response.data.name);
        } catch (error) {
            console.error('Error fetching report card:', error);
            setError(error.response?.data?.message || 'Failed to fetch report card data');
        }
    }


    const closeUpdateModal = () => {
        setupdateModal(false)
        setupdateStudentDataId("")
        setupdateStudentMonth("")
        setupdateStudentRubricType("")
        setSkillChanges({});
    };


    // const updateMonthFilterHandler = (e) => {
    //     const value = e.target.value;
    //     setupdateStudentMonth(value);
    //     filterUpdateRubric(value, updateStudentRubricType);
    // };

    // const updateRubricTypeChangeHandler = (e) => {
    //     const value = e.target.value;
    //     setupdateStudentRubricType(value);
    //     filterUpdateRubric(updateStudentMonth, value);
    // };

    // 1. Remove filterUpdateRubric() calls from onChange handlers
    const updateMonthFilterHandler = (e) => {
        setupdateStudentMonth(e.target.value);
    };

    const updateRubricTypeChangeHandler = (e) => {
        setupdateStudentRubricType(e.target.value);
    };

    // 2. Add this useEffect — this is the magic fix
    useEffect(() => {
        // console.log("useEffect triggered → Month:", updateStudentMonth, "Type:", updateStudentRubricType);

        if (!updateAllData || !updateAllData.rubric_data || updateAllData.rubric_data.length === 0) {
            setFilteredUpdateRubricData([]);
            return;
        }

        const monthSelected = updateStudentMonth && updateStudentMonth.trim() !== "";
        const typeSelected = updateStudentRubricType && updateStudentRubricType.trim() !== "";

        if (!monthSelected || !typeSelected) {
            setFilteredUpdateRubricData([]);
            return;
        }

        const filtered = updateAllData.rubric_data.filter(rubric => {
            const matchesMonth =
                (rubric.month && rubric.month === updateStudentMonth) ||
                (rubric.rubric_month && rubric.rubric_month === updateStudentMonth);

            const matchesType = rubric.rubric_type === updateStudentRubricType;

            return matchesMonth && matchesType;
        });

        // console.log("Filtered data:", filtered);
        setFilteredUpdateRubricData(filtered);

    }, [updateStudentMonth, updateStudentRubricType, updateAllData]); // dependencies



    useEffect(() => {
        if (updateModal) {
            // Reset filters when modal opens
            setupdateStudentMonth("");
            setupdateStudentRubricType("");
            setFilteredUpdateRubricData([]);
            setSkillChanges({});

        }
    }, [updateModal]);


    useEffect(() => {
        if (!filteredUpdateRubricData.length) return;

        const rubric = filteredUpdateRubricData[0];

        setParentsSuggestion(rubric.parents_suggestion || '');
        setReferenceUrl(rubric.reference_url || '');
        setupdatestarRating(rubric.star || 0);

    }, [filteredUpdateRubricData]);


    // const filterUpdateRubric = (month, type) => {

    //     if (!updateAllData || !updateAllData.rubric_data) {
    //         setFilteredUpdateRubricData([]);
    //         return;
    //     }
    //     const all = updateAllData.rubric_data;
    //     // If no filters selected → show blank
    //     if (!month && !type) {
    //         setFilteredUpdateRubricData([]);
    //         return;
    //     }
    //     let result = all;
    //     if (month) {
    //         result = result.filter(r =>
    //             r.month === month || r.rubric_month === month
    //         );
    //     }
    //     if (type) {
    //         result = result.filter(r =>
    //             r.rubric_type === type
    //         );
    //     }
    //     setFilteredUpdateRubricData(result);
    // };


    const filterUpdateRubric = () => {
        if (!updateAllData || !updateAllData.rubric_data || updateAllData.rubric_data.length === 0) {
            setFilteredUpdateRubricData([]);
            return;
        }

        const monthSelected = updateStudentMonth && updateStudentMonth.trim() !== "";
        const typeSelected = updateStudentRubricType && updateStudentRubricType.trim() !== "";

        console.log("Filtering with - Month:", updateStudentMonth, "Type:", updateStudentRubricType);
        // Only filter and show data if BOTH are selected
        if (!monthSelected || !typeSelected) {
            setFilteredUpdateRubricData([]);
            return;
        }

        const filtered = updateAllData.rubric_data.filter(rubric => {
            const matchesMonth =
                (rubric.month && rubric.month === updateStudentMonth) ||
                (rubric.rubric_month && rubric.rubric_month === updateStudentMonth);

            const matchesType =
                rubric.rubric_type === updateStudentRubricType;

            return matchesMonth && matchesType;
        });

        setFilteredUpdateRubricData(filtered);
    };


    const handleupdateStudent = async (id, updateStudentMonth, updateStudentRubricType, rubricDataId) => {
        if (!id || !updateStudentMonth || !updateStudentRubricType || !rubricDataId) {
            setResetResult("Please select all fields.");
            return;
        }
        setResetLoading(true);
        setResetResult("");
        try {
            console.log("Sending delete request to API...");
            const res = await axios.put(`${API}/students-upload/update-rubric/${id}/${rubricDataId}`, {
                month: updateStudentMonth,
                rubric_type: updateStudentRubricType,
                session: fetchedSession,
                _id: rubricDataId
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            });
            setResetResult(res.data.message || "Rubric update successful.");
            alert(`Rubric for ${updateStudentMonth} updated successfully!`);
            setupdateTable(!updateTable);
            closeUpdateModal();
        } catch (err) {
            setResetResult(err.response?.data?.message || "Error updating rubric.");
        }
        setResetLoading(false);
    };


    const handleSkillChange = (skillId, newValue) => {
        setSkillChanges(prev => ({
            ...prev,
            [skillId]: newValue
        }));
    };




    // Check if a skill has been changed
    const hasChanged = (skill) => skillChanges[skill._id?.$oid || skill._id] !== undefined;

    // Get the new value (or fallback to original)
    const getCurrentValue = (skill) =>
        skillChanges[skill._id?.$oid || skill._id] || skill.skill_answer;


    const handleSaveAllChanges = async () => {
        const updates = Object.entries(skillChanges).map(([skillId, newAnswer]) => ({
            skillId,
            newAnswer
        }));

        try {
            const res = await fetch(`${API}/students-upload/update-skills-bulk`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    studentId: updateAllData._id?.$oid || updateAllData._id,
                    rubricType: updateStudentRubricType,
                    month: updateStudentMonth,
                    updates,
                    parents_suggestion: parentsSuggestion,
                    reference_url: referenceUrl,
                    star: updatestarRating
                })
            });

            const data = await res.json();
            if (data.success) {
                alert("All changes saved successfully!");
                setSkillChanges({}); // clear changes
                closeUpdateModal();
                // Optionally refetch data
            } else {
                alert("Error: " + data.message);
            }
        } catch (err) {
            alert("Network error");
        }
    };

    // ======================== Operation on update student that will access later end==================



    // ==========operation on reset student data start ==================
    // operation on reset student data start 
    // state and function for reset rubric modal
    const [showResetRubricModal, setShowResetRubricModal] = useState(false);
    const [resetAllData, setResetAllData] = useState(false);
    const [resetStudentId, setResetStudentId] = useState("");
    const [resetStudentName, setResetStudentName] = useState("");
    const [resetRubricMonth, setResetRubricMonth] = useState("");
    const [resetRubricType, setResetRubricType] = useState("");
    const [resetSession, setResetSession] = useState("");
    const [resetResult, setResetResult] = useState("");
    const [resetLoading, setResetLoading] = useState(false);

    const [filteredRubricData, setFilteredRubricData] = useState([]);


    // open reset modal
    const openResetModal = async (id) => {
        setResetStudentId(id);
        setShowResetRubricModal(true);

        setResetLoading(true);
        setError(null);

        try {
            const response = await axios.get(`${API}/report-card/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token'),
                },
            });
            // console.log('API Response:', response.data); // Debug log
            setResetAllData(response.data);
            setResetStudentName(response.data.name);
        } catch (error) {
            console.error('Error fetching report card:', error);
            setError(error.response?.data?.message || 'Failed to fetch report card data');
        } finally {
            setResetLoading(false);
        }
    };



    // close reset modal
    const closeResetModal = () => {
        setShowResetRubricModal(false);
        setResetStudentId("");
        setResetStudentName("")
        setResetRubricMonth("");
        setResetRubricType("");
        setResetSession("");
        setResetResult("");


    };


    // state (add if not already)
    // const [filteredRubricData, setFilteredRubricData] = useState([]);

    // normalize helper (case-insensitive, trims)
    const norm = v => (typeof v === "string" ? v.trim() : v);

    // fix handlers so they pass the NEW value into filterRubric
    const resetSearchHandler = (e) => {
        const value = e.target.value;
        setResetRubricMonth(value);
        filterRubric(value, resetRubricType);
    };

    const handleRubricTypeChange = (e) => {
        const value = e.target.value;
        setResetRubricType(value);
        filterRubric(resetRubricMonth, value);
    };


    // console.log(userData.role)
    const filterRubric = (month, type) => {
        if (!resetAllData || !resetAllData.rubric_data) {
            setFilteredRubricData([]);
            return;
        }

        const all = resetAllData.rubric_data;

        // If no filters selected → show blank
        if (!month && !type) {
            setFilteredRubricData([]);
            return;
        }

        let result = all;

        if (month) {
            result = result.filter(r =>
                r.month === month || r.rubric_month === month
            );
        }

        if (type) {
            result = result.filter(r =>
                r.rubric_type === type
            );
        }

        setFilteredRubricData(result);
    };




    // Function to call API for resetting rubric data
    const handleResetRubric = async (id, resetRubricMonth, resetRubricType, rubricDataId) => {
        if (!id || !resetRubricMonth || !resetRubricType || !rubricDataId) {
            setResetResult("Please select all fields.");
            return;
        }
        setResetLoading(true);
        setResetResult("");
        try {
            console.log("Sending delete request to API...");
            const res = await axios.delete(`${API}/students-upload/reset-rubric/${id}/${rubricDataId}`, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                },
                data: {
                    month: resetRubricMonth,
                    rubric_type: resetRubricType,
                    session: fetchedSession,
                    _id: rubricDataId
                }
            });
            setResetResult(res.data.message || "Rubric reset successful.");
            alert(`Rubric for ${resetRubricMonth} reset successfully!`);
            setupdateTable(!updateTable);
            closeResetModal();
        } catch (err) {
            setResetResult(err.response?.data?.message || "Error resetting rubric.");
        }
        setResetLoading(false);
    };

    // before render (inside component)
    const displayRubrics = filteredRubricData; // only filtered data

    // operation on reset student data end
    // operation on reset student data end


    // ===================operation on report card start =====================
    const [showReportCard, setShowReportCard] = useState(false);
    const [reportData, setReportData] = useState(null); // Initialize as null
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filterReportMonths, setfilterReportMonths] = useState("")
    const RUBRIC_ORDER = ["Literacy", "Numeracy", "Hindi"];
    // const handleReportCard = async (id) => {
    //     setShowReportCard(true);
    //     setLoading(true);
    //     setError(null);

    //     try {
    //         const response = await axios.get(`${API}/report-card/${id}`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'token': localStorage.getItem('token'),
    //             },
    //         });
    //         setReportData(response.data);
    //     } catch (error) {
    //         console.error('Error fetching report card:', error);
    //         setError(error.response?.data?.message || 'Failed to fetch report card data');
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const handleReportCard = async (id) => {
        setShowReportCard(true);
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(`${API}/report-card/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token'),
                },
            });
            // console.log('API Response:', response.data); // Debug log
            setReportData(response.data);
        } catch (error) {
            console.error('Error fetching report card:', error);
            setError(error.response?.data?.message || 'Failed to fetch report card data');
        } finally {
            setLoading(false);
        }
    };

    // Resolves teacher_name whether it's a populated user object, a plain string,
    // or null (populate returns null when the referenced teacher no longer exists)
    const getTeacherDisplayName = (teacherName) => {
        if (teacherName && typeof teacherName === 'object') {
            return teacherName.name || 'N/A';
        }
        return teacherName || 'N/A';
    };

    // Function to safely parse dates
    const parseDate = (dateObj) => {
        if (dateObj?.$date) {
            return new Date(dateObj.$date).toLocaleString();
        }
        return new Date(dateObj).toLocaleString();
    };

    // Group and sort rubric data by month and session
    const groupRubricData = (rubricData) => {
        if (!rubricData || !Array.isArray(rubricData)) {
            console.warn('rubricData is not an array:', rubricData);
            return [];
        }
        const monthOrder = [
            'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
            'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
        ];
        const grouped = {};
        rubricData.forEach((rubric) => {
            const key = `${rubric.month}-${rubric.session}`;
            if (!grouped[key]) {
                grouped[key] = {
                    month: rubric.month,
                    session: rubric.session,
                    rubrics: [],
                };
            }
            grouped[key].rubrics.push(rubric);
        });
        return Object.values(grouped)
            .map(group => ({
                ...group,
                rubrics: RUBRIC_ORDER
                    .map(type =>
                        group.rubrics.find(r => r.rubric_type === type)
                    )
                    .filter(Boolean) // removes missing rubric types safely
            }))
            .sort((a, b) => {
                const monthA = monthOrder.indexOf(a.month.toUpperCase());
                const monthB = monthOrder.indexOf(b.month.toUpperCase());
                return monthA - monthB;
            });
    };

    // Print function
    // Export PDF function




    // const handlePrint = () => {
    //     const printContents = document.getElementById(`printable`).innerHTML;
    //     const printWindow = window.open('', '', 'height=600,width=800');
    //     printWindow.document.write('<html><head><title>Literacy And Numeracy Assessment</title>');

    //     // Add styles for printing
    //     printWindow.document.write(`
    //         <style>
    //             @media print {
    //                 body * {
    //                     visibility: hidden;

    //                 }
    //                 .printable, .printable * {
    //                     visibility: visible;
    //                 }
    //                 .printable {
    //                     position: absolute;
    //                     top: 0;
    //                     left: 0;
    //                     width: 100%;
    //                     height: 100%;
    //                     // border: 2px solid red;
    //                     box-sizing: border-box;

    //                 }
    //                 .printable button, .printable #button, .printable #button * {
    //                     display:none;
    //                 }
    //                 .printable select{
    //                     display:none;
    //                 }

    //                 .printable .disFlexJCIC{
    //                     display:flex;
    //                     justify-content:space-between;
    //                     align-items:center;
    //                 }
    //                 .printable .mb-2{
    //                     margin-bottom:0px
    //                 }
    //                 .printable mb-4{
    //                     margin-bottom:0px
    //                 }
    //                 .printable img {
    //                     display: block;
    //                     width: 80%;
    //                     max-height: 120px;
    //                     object-fit: contain;
    //                 }
    //                 .printable br[id="button"] {
    //                     visibility: hidden;
    //                 }
    //                 @page {
    //                    margin:10px 75px 10px 75px;
    //                     padding: 5px;
    //                 }
    //                 footer {
    //                     display: none;
    //                 }
    //             }

    //             .printable  .logo {
    //                 display:flex;
    //                 justify-content:center;
    //                 margin-left: auto;
    //                 margin-right: auto;
    //             }
    //             .printable h1, .printable h2 {
    //                 text-align: center;
    //             }
    //             .printable p {
    //                 margin: 0;
    //                 padding: 0;
    //             }

    //             .printable table {
    //                 width: 100%;
    //                 border-collapse: collapse;
    //             }
    //             .printable th, .printable td {
    //                 border: 2px solid black;
    //                 padding: 8px;
    //                 text-align: center;
    //             }
    //             .printable .bg-gray-200 {
    //                 background-color: #e5e7eb;
    //             }
    //             .printable .bg-gray-100 {
    //                 background-color: #f3f4f6;
    //             }
    //             .printable .text-center {
    //                 text-align: center;
    //             }
    //             .printable .border-2 {
    //                 border-width: 1px;
    //             }
    //             .printable .border-black {
    //                 border-color: black;
    //             }
    //             .printable .p-2 {
    //                 padding: 8px;
    //             }
    //             .printable .margin_top {
    //                 margin-top:80px
    //             }
    //             .printable .py-\[10px\] {
    //                 padding-top: 10px;
    //                 padding-bottom: 10px;
    //             }
    //             .printable .flex {
    //                 display: flex;
    //             }
    //             .printable .flex-col {
    //                 flex-direction: column;
    //             }
    //             .printable .justify-center {
    //                 justify-content: center;
    //             }
    //             .printable .items-center {
    //                 align-items: center;
    //             }
    //             .printable .gappppp {
    //                 gap: 150px;
    //             }
    //             .printable .mt-2 {
    //                 margin-top: 8px;
    //             }
    //             .printable .text-\[22px\] {
    //                 font-size: 22px;
    //             }
    //             .printable .font-semibold {
    //                 font-weight: 600;
    //             }
    //             .printable .w-\[80\%\] {
    //                 width: 80%;
    //             }
    //             .printable .note {
    //                 width: 200px;
    //             }
    //             .printable .max-h-\[120px\] {
    //                 max-height: 120px;
    //             }
    //             .printable .object-contain {
    //                 object-fit: contain;
    //             }
    //             .printable .border-dotted {
    //                 border-style: dotted;
    //             }
    //         </style>
    //     `);

    //     printWindow.document.write('</head><body>');
    //     printWindow.document.write(`<div class="printable">${printContents}</div>`);
    //     printWindow.document.write('</body></html>');
    //     printWindow.document.close();
    //     printWindow.print();
    // };

    // const handlePrint = () => {
    //     const printContents = document.getElementById(`printable`).innerHTML;
    //     const printWindow = window.open('', '', 'height=600,width=800');
    //     printWindow.document.write('<html><head><title>Literacy And Numeracy Assessment</title>');

    //     // Add styles for printing
    //     printWindow.document.write(`
    //   <style>
    //     @media print {
    //       body {
    //         font-family: 'Arial', sans-serif;
    //         margin: 0;
    //         padding: 0;
    //       }
    //       .printable, .printable * {
    //         visibility: visible;
    //       }
    //       .printable {
    //         position: absolute;
    //         top: 0;
    //         left: 0;
    //         width: 100%;
    //         box-sizing: border-box;
    //         padding: 20px;
    //       }
    //       .printable button, .printable select {
    //         display: none;
    //       }
    //       .printable #school-logo {
    //         display: block;
    //         width: 100px;
    //         max-height: 100px;
    //         object-fit: contain;
    //         margin: 0 auto;
    //       }
    //       @page {
    //         margin: 15mm 10mm;
    //       }
    //       .footer {
    //         position: running(footer);
    //         text-align: center;
    //         font-size: 10px;
    //         color: #555;
    //       }
    //       @page {
    //         @bottom-center {
    //           content: counter(page) " of " counter(pages) " ;
    //         }
    //       }
    //     }
    //     .printable .logo_container{
    //       display: flex;
    //       justify-content: center;
    //       margin-bottom: 15px;
    //     }
    //     .printable .logo {
    //       width :100px;
    //       height:100px;
    //     }
    //     .printable h1 {
    //       text-align: center;
    //       font-size: 24px;
    //       color: #1a202c;
    //       margin-bottom: 15px;
    //       border-bottom: 2px solid #e2e8f0;
    //       padding-bottom: 5px;
    //     }
    //     .printable h2 {
    //       font-size: 18px;
    //       color: #2d3748;
    //       margin-bottom: 10px;
    //     }
    //     .printable h3 {
    //       font-size: 16px;
    //       color: #2d3748;
    //       margin-bottom: 8px;
    //       border-left: 4px solid #4a5568;
    //       padding-left: 8px;
    //     }
    //     .printable h4 {
    //       font-size: 14px;
    //       color: #2d3748;
    //     }
    //     .printable h5 {
    //       font-size: 12px;
    //       color: #4a5568;
    //       margin-bottom: 5px;
    //     }
    //     .printable p {
    //       font-size: 12px;
    //       color: #4a5568;
    //       margin: 3px 0;
    //     }
    //     .printable table {
    //       width: 100%;
    //       border-collapse: collapse;
    //       margin-bottom: 15px;
    //     }
    //     .printable th, .printable td {
    //       border: 1px solid #000;
    //       padding: 8px;
    //       font-size: 12px;
    //       text-align: left;
    //     }
    //     .printable th {
    //       background-color: #e2e8f0;
    //       font-weight: bold;
    //     }
    //     .printable tbody tr:nth-child(even) {
    //       background-color: #f7fafc;
    //     }
    //     .printable .bg-gray-50 {
    //       background-color: #f9fafb;
    //       padding: 10px;
    //       border: 1px solid #e2e8f0;
    //       border-radius: 4px;
    //       margin-bottom: 10px;
    //     }
    //     .printable .bg-white {
    //       background-color: #ffffff;
    //       border: 1px solid #e2e8f0;
    //       border-radius: 4px;
    //       padding: 10px;
    //     }
    //     .printable .border-gray-200 {
    //       border: 1px solid #e2e8f0;
    //     }
    //     .printable .border-gray-400 {
    //       border: 1px solid #000;
    //     }
    //     .printable .text-yellow-500 {
    //       color: #000;
    //       font-weight: bold;
    //     }
    //     .printable .text-blue-500 {
    //       color: #000;
    //       text-decoration: none;
    //     }
    //     .printable .flex {
    //       display: flex;
    //     }
    //     .printable .justify-between {
    //       justify-content: space-between;
    //     }
    //     .printable .disFlexJCIC {
    //       display: flex;
    //       justify-content: space-between;
    //       align-items: center;
    //     }
    //     .printable .items-center {
    //       align-items: center;
    //     }
    //     .printable .grid {
    //       display: grid;
    //     }
    //     .printable .md\\:grid-cols-2 {
    //       grid-template-columns: repeat(2, minmax(0, 1fr));
    //     }
    //     .printable .gap-2 {
    //       gap: 8px;
    //     }
    //     .printable .mb-4 {
    //       margin-bottom: 16px;
    //     }
    //     .printable .mb-2 {
    //       margin-bottom: 8px;
    //     }
    //     .printable .mt-4 {
    //       margin-top: 16px;
    //     }
    //     .printable .space-y-2 > * + * {
    //       margin-top: 8px;
    //     }
    //     .printable .space-y-8 > * + * {
    //       margin-top: 16px;
    //     }
    //     .printable .text-sm {
    //       font-size: 12px;
    //     }
    //     .printable .font-medium {
    //       font-weight: 500;
    //     }
    //     .printable .font-semibold {
    //       font-weight: 600;
    //     }
    //     .printable .border-dotted {
    //       border-style: dotted;
    //     }
    //   </style>
    // `);

    //     printWindow.document.write('</head><body>');
    //     printWindow.document.write(`
    //   <div class="printable">${printContents}</div>
    // `);
    //     printWindow.document.write('</body></html>');
    //     printWindow.document.close();
    //     printWindow.print();
    // };





    // const handlePrint = () => {
    //     const element = document.getElementById('printable');
    //     if (!element) {
    //         console.error('Element with ID "printable" not found');
    //         return;
    //     }

    //     // Temporarily adjust styles to capture full content and center table text
    //     const scrollableDiv = element.querySelector('.overflow-y-scroll');
    //     const tableCells = element.querySelectorAll('tbody td');
    //     const originalStyles = {
    //         overflow: scrollableDiv ? scrollableDiv.style.overflow : null,
    //         maxHeight: scrollableDiv ? scrollableDiv.style.maxHeight : null,
    //         height: element.style.height,
    //         tableCells: Array.from(tableCells).map(td => ({
    //             textAlign: td.style.textAlign,
    //             verticalAlign: td.style.verticalAlign,
    //         })),
    //     };

    //     if (scrollableDiv) {
    //         scrollableDiv.style.overflow = 'visible';
    //         scrollableDiv.style.maxHeight = 'none';
    //     }
    //     element.style.height = 'auto';
    //     tableCells.forEach(td => {
    //         td.style.textAlign = 'center'; // Horizontal centering
    //         td.style.verticalAlign = 'middle'; // Vertical centering
    //     });

    //     html2canvas(element, {
    //         scale: 2, // Increase resolution for better quality
    //         useCORS: true, // Enable CORS for external images (e.g., logo)
    //         logging: false,
    //         windowWidth: element.scrollWidth,
    //         windowHeight: element.scrollHeight, // Capture full scrollable content
    //     }).then(canvas => {
    //         // Restore original styles
    //         if (scrollableDiv) {
    //             scrollableDiv.style.overflow = originalStyles.overflow;
    //             scrollableDiv.style.maxHeight = originalStyles.maxHeight;
    //         }
    //         element.style.height = originalStyles.height;
    //         tableCells.forEach((td, index) => {
    //             td.style.textAlign = originalStyles.tableCells[index].textAlign;
    //             td.style.verticalAlign = originalStyles.tableCells[index].verticalAlign;
    //         });

    //         const imgData = canvas.toDataURL('image/png');
    //         const pdf = new jsPDF({
    //             orientation: 'portrait',
    //             unit: 'mm',
    //             format: 'a4',
    //         });

    //         const pageWidth = pdf.internal.pageSize.getWidth();
    //         const pageHeight = pdf.internal.pageSize.getHeight();
    //         const imgWidth = pageWidth - 20; // 10mm margin on each side
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //         let heightLeft = imgHeight;
    //         let position = 0;

    //         // Add first page
    //         pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
    //         heightLeft -= pageHeight - 20; // Account for margins

    //         // Add additional pages if content exceeds one page
    //         while (heightLeft > 0) {
    //             position = heightLeft - imgHeight;
    //             pdf.addPage();
    //             pdf.addImage(imgData, 'PNG', 10, position + 10, imgWidth, imgHeight);
    //             heightLeft -= pageHeight - 20;
    //         }

    //         // Save the PDF
    //         pdf.save('Literacy_And_Numeracy_Assessment.pdf');
    //     }).catch(error => {
    //         // Restore original styles in case of error
    //         if (scrollableDiv) {
    //             scrollableDiv.style.overflow = originalStyles.overflow;
    //             scrollableDiv.style.maxHeight = originalStyles.maxHeight;
    //         }
    //         element.style.height = originalStyles.height;
    //         tableCells.forEach((td, index) => {
    //             td.style.textAlign = originalStyles.tableCells[index].textAlign;
    //             td.style.verticalAlign = originalStyles.tableCells[index].verticalAlign;
    //         });

    //         console.error('Error generating PDF:', error);
    //         alert('An error occurred while generating the PDF. Please try again.');
    //     });
    // };



    // this is the working code start
    // const handleDownloadPDF = async () => {
    //     const input = document.getElementById("printable");

    //     // Add the printable class to remove scroll limitations
    //     input.classList.add("printable");

    //     // Wait for the DOM to re-render
    //     await new Promise((resolve) => setTimeout(resolve, 100));

    //     // Capture the entire content with html2canvas
    //     const canvas = await html2canvas(input, {
    //         scale: 1.5, // Adjust scale as needed
    //         useCORS: true,
    //         scrollX: 0,
    //         scrollY: 0,
    //         windowWidth: input.scrollWidth,
    //         windowHeight: input.scrollHeight,
    //     });

    //     const imgData = canvas.toDataURL("image/png");

    //     const pdf = new jsPDF("p", "mm", "a4");
    //     const pdfWidth = pdf.internal.pageSize.getWidth() - 20; // 5mm margin on each side (left + right = 10mm)
    //     const pdfHeight = pdf.internal.pageSize.getHeight() - 10; // 5mm margin on top and bottom (top + bottom = 10mm)
    //     const imgWidth = pdfWidth;
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //     // Calculate x and y offsets to center the content
    //     const xOffset = 10; // Left margin (to center horizontally, we start at the left margin)
    //     const yOffset = 5; // Top margin (to center vertically, we start at the top margin)

    //     let heightLeft = imgHeight;
    //     let position = 0;

    //     // Add the first page
    //     pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
    //     heightLeft -= pdfHeight;

    //     // Add additional pages if content overflows
    //     while (heightLeft > 0) {
    //         position = heightLeft - imgHeight;
    //         pdf.addPage();
    //         pdf.addImage(imgData, "PNG", xOffset, position + yOffset, imgWidth, imgHeight);
    //         heightLeft -= pdfHeight;
    //     }

    //     // Save the PDF
    //     pdf.save("ReportCard.pdf");

    //     // Remove the printable class
    //     input.classList.remove("printable");
    // };
    // this is the working code end


    const handleDownloadPDF = async () => {
        const input = document.getElementById("printable");
        input.classList.add("printable");

        await new Promise((resolve) => setTimeout(resolve, 200));

        const canvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
        });

        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const marginTop = 25;
        const marginBottom = 25;
        const marginLeft = 10;
        const marginRight = 10;

        const usableWidth = pageWidth - marginLeft - marginRight;
        const usableHeight = pageHeight - marginTop - marginBottom;

        const scale = usableWidth / canvas.width;
        const pageCanvasHeight = usableHeight / scale;

        let renderedHeight = 0;
        let pageIndex = 0;

        while (renderedHeight < canvas.height) {
            // 🔥 Slice canvas per page
            const pageCanvas = document.createElement("canvas");
            pageCanvas.width = canvas.width;
            pageCanvas.height = Math.min(pageCanvasHeight, canvas.height - renderedHeight);

            const ctx = pageCanvas.getContext("2d");
            ctx.drawImage(
                canvas,
                0,
                renderedHeight,
                canvas.width,
                pageCanvas.height,
                0,
                0,
                canvas.width,
                pageCanvas.height
            );

            const imgData = pageCanvas.toDataURL("image/png");

            if (pageIndex > 0) pdf.addPage();

            pdf.addImage(
                imgData,
                "PNG",
                marginLeft,
                marginTop,
                usableWidth,
                pageCanvas.height * scale
            );

            renderedHeight += pageCanvasHeight;
            pageIndex++;
        }

        pdf.save("ReportCard.pdf");
        input.classList.remove("printable");
    };


    // print report card end


    // export pdf start 

    // export pdf end
    // ===================operation on report card end =====================

    return (
        <div>
            <div>
                <Sidebar>
                    <div className='bg-theme_sky_blue h-[10vh] w-full flex items-center px-[20px] text-theme_white'>
                        <div>
                            <p>Students</p>
                        </div>
                    </div>


                    {/* page content start  */}

                    <div className='m-[15px] flex gap-3 items-center'>
                        <div className='w-[20%]'>
                            <label >Search Name:</label>
                            <input onChange={handleNameChange}
                                value={searchName}
                                type="search"
                                className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' />
                        </div>

                        <div className='w-[20%]'>
                            <label >Search Class:</label>
                            <select value={selectedClass}
                                onChange={handleClassChange}
                                disabled={get_section.length === 0} className=' w-full ' >
                                <option value="" >Select Class</option>
                                {
                                    get_section && get_section.map((item, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <option value={item.class_name}>{item.class_name}</option>
                                            </Fragment>
                                        )
                                    })
                                }
                            </select>
                        </div>

                        <div className='w-[20%]'>
                            <label >Search Section:</label>
                            <select onChange={handleSectionChange} disabled={!selectedClass || sections.length === 0} className='w-full' >
                                <option value="" >Select Section</option>
                                {
                                    sections && sections.map((item, index) => {
                                        return (

                                            <option key={index} value={item}>{item}</option>

                                        )
                                    })
                                }
                            </select>
                        </div>

                        <div className='w-[20%]'>
                            <label>Search Session:</label>

                            {
                                userData.role == "Super Admin" ? (
                                    <>
                                        <select
                                            value={selectedSession}
                                            onChange={handleSessionChange}
                                            className='w-full'
                                        >
                                            <option value="">Select Session</option>
                                            {
                                                allSessionData?.map((item, index) => (
                                                    <option key={index} value={item.name}>
                                                        {item.name}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </>
                                ) : (
                                    <input
                                        type="text"
                                        value={fetchedSession}
                                        disabled
                                        className='bg-gray-100 px-[10px] py-[5px] w-full rounded-3xl border border-gray-300'
                                    />
                                )
                            }
                        </div>
                        <div className='w-[20%]'>
                            <label >Search Assessment Period:</label>
                            {/* <input type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' /> */}
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                className=' w-full' >
                                <option value="">Select Month</option>
                                {
                                    allMonthsData && allMonthsData.map((item, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <option value={item.name}>{item.name}</option>
                                            </Fragment>
                                        )
                                    })
                                }

                            </select>
                        </div>

                        <div className='ml-auto flex items-center gap-2'>
                            {/* {
                                (userData.role === 'Admin' || userData.role ==="Super Admin") ? ( */}
                            <button onClick={() => setshowEmailModal(true)} className='bg-theme_blue text-[12px] text-theme_white px-[20px] py-[5px]'>
                                Send Email ({selectedStudents.length})
                            </button>
                            {/* ) : null
                            } */}
                            <DownloadTableExcel
                                filename="Brainbench_Students_Data"
                                sheet='students'
                                currentTableRef={tableRef.current}
                            >
                                <button className='bg-theme_yellow_dark text-[12px] text-theme_white px-[20px] py-[5px]'>Export</button>

                            </DownloadTableExcel>

                        </div>

                    </div>

                    <div className='p-[20px] h-[60vh]  overflow-scroll'>
                        <table className='w-full' >
                            <thead className='sticky top-[-20px] bg-white'>

                                {/* <th>sno.</th> */}
                                {/* {
                                    (userData.role === 'Admin' || userData.role=== "Super Admin") ? ( */}
                                <th>
                                    <label >Send Email </label>
                                    <input type="checkbox" onChange={handleSelectAll} checked={selectedStudents.length === filteredStudents.length && filteredStudents.length > 0} />
                                </th>
                                {/* ) : null
                                } */}
                                {/* {
                                    userData.role === 'Admin' ? ( */}
                                <th>Reset</th>
                                {/* ) : null
                                } */}
                                <th>StudentId</th>
                                <th>Session</th>
                                {/* <th>Assessment period</th> */}
                                <th>Name</th>
                                <th>Class</th>
                                <th>Section</th>
                                <th>Teacher Name</th>
                                <th>Assess</th>
                                <th>Update</th>
                                <th>Report Card</th>
                                {/* <th>Delete</th> */}
                                {/* <th>Comments</th> */}
                                {/* <th>Parents Suggestion</th> */}

                            </thead>
                            <tbody>
                                {
                                    filteredStudents && filteredStudents.map((item, index) => {
                                        // console.log(filteredStudents)
                                        if (item.rubric_data && item.rubric_data.length > 0) {
                                            return (
                                                <tr key={index} className='text-center border border-gray-300 hover:bg-gray-100'>
                                                    {/* {
                                                        (userData.role === 'Admin' || userData.role === "Super Admin") ? ( */}
                                                            <td>

                                                                <input type="checkbox" checked={selectedStudents.includes(item._id)} onChange={() => handleSelectStudent(item._id)} />
                                                            </td>
                                                        {/* ) : null
                                                    } */}
                                                    {/* <td>dsf</td> */}
                                                    {/* {
                                                        userData.role === 'Admin' ? ( */}
                                                    <td><button onClick={() => openResetModal(item._id)} className='bg-theme_red px-[20px] py-[3px] rounded-3xl text-theme_white'><IoIosRemoveCircle /></button></td>
                                                    {/* ) : null
                                                    } */}
                                                    <td>{item.student_id}</td>
                                                    <td>{item.session}</td>
                                                    {/* <td>{item.month}</td> */}
                                                    <td>{item.name}</td>
                                                    <td>{item.classes}</td>
                                                    <td>{item.section}</td>
                                                    <td>{getTeacherDisplayName(item.teacher_name)}</td>
                                                    <td><button onClick={() => handleAsssess(item._id)} className='bg-theme_blue px-[20px] py-[5px] rounded-3xl text-theme_white'>Assess</button></td>
                                                    <td><MdEditDocument onClick={() => openUpdateModal(item._id)} size={20} /></td>
                                                    <td><HiDocumentReport onClick={() => handleReportCard(item._id)} size={20} /></td>

                                                </tr>
                                            )
                                        } else {
                                            return (
                                                //write border css
                                                <tr key={index} className='text-center border border-gray-300 hover:bg-gray-100'>
                                                    <td>
                                                        <input type="checkbox" checked={selectedStudents.includes(item._id)} onChange={() => handleSelectStudent(item._id)} />
                                                    </td>
                                                    {/* <td>dsf</td> */}
                                                    {/* {
                                                        userData.role === 'Admin' ? ( */}
                                                    <td>-</td>
                                                    {/* ) : null
                                                    } */}
                                                    <td>{item.student_id}</td>
                                                    <td>{item.session}</td>
                                                    {/* <td>{item.month}</td> */}
                                                    <td>{item.name}</td>
                                                    <td>{item.classes}</td>
                                                    <td>{item.section}</td>
                                                    {/* <td>{item.teacher_name}</td> */}
                                                    <td>{getTeacherDisplayName(item.teacher_name)}</td>
                                                    <td><button onClick={() => handleAsssess(item._id)} className='bg-theme_blue px-[20px] py-[5px] rounded-3xl text-theme_white'>Assess</button></td>
                                                    <td>-</td>

                                                </tr>
                                            )
                                        }
                                    })
                                }
                            </tbody>
                        </table>

                        <table ref={tableRef} className="hidden w-full border-collapse border border-gray-400 text-sm">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border border-gray-400 px-4 py-3 text-left">Month</th>
                                    <th className="border border-gray-400 px-6 py-3 text-left">Rubric Type</th>
                                    <th className="border border-gray-400 px-8 py-3 text-left">Skill Name</th>
                                    <th className="border border-gray-400 px-4 py-3 text-center">Skill Answer</th>
                                    <th className="border border-gray-400 px-3 py-3 text-center">Classes</th>
                                    <th className="border border-gray-400 px-3 py-3 text-center">Section</th>
                                    <th className="border border-gray-400 px-6 py-3 text-left">Name</th>
                                    <th className="border border-gray-400 px-6 py-3 text-left">Teacher Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStudents.map((student) => {
                                    const name = student.name;
                                    const classes = student.classes;
                                    const section = student.section;
                                    const teacherName = getTeacherDisplayName(student.teacher_name);

                                    if (!student.rubric_data || student.rubric_data.length === 0) {
                                        return (
                                            <tr key={student._id}>
                                                <td colSpan="8" className="text-center py-10 text-gray-500">No assessment data</td>
                                            </tr>
                                        );
                                    }

                                    // Count total skills for rowspan
                                    const totalSkills = student.rubric_data.reduce((acc, rubric) => acc + rubric.rubric_skills.length, 0);
                                    let skillCounter = 0;

                                    return student.rubric_data.map((rubric, rubricIdx) => {
                                        const month = rubric.month || "October-November";
                                        const rubricType = rubric.rubric_type.toUpperCase();
                                        const skills = rubric.rubric_skills;

                                        return skills.map((skill, skillIdx) => {
                                            const isFirstRowOfStudent = skillCounter === 0;
                                            const isFirstSkillOfRubric = skillIdx === 0;
                                            skillCounter++;

                                            const answer = skill.skill_answer;
                                            const answerColor =
                                                answer === "ACHIEVED" ? "text-green-700 font-bold" :
                                                    answer === "DEVELOPING" ? "text-orange-600 font-bold" :
                                                        "text-red-700 font-bold";

                                            return (
                                                <tr key={`${student._id}-${rubricIdx}-${skillIdx}`} className="hover:bg-gray-50">

                                                    {/* Month - only once per student */}
                                                    {isFirstRowOfStudent && (
                                                        <td rowSpan={totalSkills} className="border border-gray-400 px-4 py-3 text-center align-middle font-medium text-gray-700">
                                                            {month}
                                                        </td>
                                                    )}

                                                    {/* Rubric Type - merged per subject */}
                                                    {isFirstSkillOfRubric && (
                                                        <td rowSpan={skills.length} className="border border-gray-400 px-4 py-3 align-middle font-semibold bg-gray-50">
                                                            {rubricType}
                                                        </td>
                                                    )}

                                                    {/* Skill Name - clean, no codes */}
                                                    <td className="border border-gray-400 pl-8 pr-4 py-3 text-gray-800">
                                                        {skill.skill_name}
                                                    </td>

                                                    {/* Skill Answer */}
                                                    <td className={`border border-gray-400 px-4 py-3 text-center ${answerColor}`}>
                                                        {answer}
                                                    </td>

                                                    {/* Student Info - merged for whole student */}
                                                    {isFirstRowOfStudent && (
                                                        <>
                                                            <td rowSpan={totalSkills} className="border border-gray-400 px-3 py-3 text-center font-medium">
                                                                {classes}
                                                            </td>
                                                            <td rowSpan={totalSkills} className="border border-gray-400 px-3 py-3 text-center font-medium">
                                                                {section}
                                                            </td>
                                                            <td rowSpan={totalSkills} className="border border-gray-400 px-4 py-3 font-medium">
                                                                {name}
                                                            </td>
                                                            <td rowSpan={totalSkills} className="border border-gray-400 px-4 py-3 font-medium">
                                                                {teacherName}
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        });
                                    });
                                })}
                            </tbody>
                        </table>
                    </div>
                    {/* page content end */}

                    {/* ==========email modal start===================  */}
                    {
                        showEmailModal && (
                            <div className='inset-0 fixed top-0 left-0 w-full h-full bg-black/80 z-20 flex items-center justify-center'>
                                <div className='w-[90%] md:w-[50%] bg-white rounded-lg p-6'>
                                    <div className='flex justify-between items-center mb-4 border-b pb-2'>
                                        <h2 className='text-xl font-bold'>Send Report Cards via Email</h2>
                                        <button onClick={() => setshowEmailModal(false)} className='text-gray-600 text-2xl hover:text-gray-800 focus:outline-none'>✕</button>
                                    </div>
                                    <div className='mb-4 text-sm text-gray-600'>
                                        You have selected <strong>{selectedStudents.length}</strong> student(s) to email.
                                    </div>

                                    <div className='grid gap-4 mb-4'>
                                        <div>
                                            <label className='block font-semibold mb-1'>Month:</label>
                                            <select value={emailMonth} onChange={(e) => setEmailMonth(e.target.value)} className='w-full border rounded px-3 py-2 outline-none focus:border-theme_sky_blue'>
                                                <option value="">Select Month</option>
                                                <option value="All">Full Session / All</option>
                                                {allMonthsData && allMonthsData.map((item, index) => (
                                                    <option key={index} value={item.name}>{item.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label className='block font-semibold mb-1'>Rubric Type:</label>
                                            {/* <select value={emailRubricType} onChange={(e) => setEmailRubricType(e.target.value)} className='w-full border rounded px-3 py-2 outline-none focus:border-theme_sky_blue'>
                                                <option value="">Select Rubric Type</option>
                                                <option value="All">Full Session / All</option>
                                                {rubricTypeAllData && rubricTypeAllData.map((item, index) => (
                                                    <option key={index} value={item.rubricType}>{item.rubricType}</option>
                                                ))}
                                            </select> */}
                                            {/* <select
                                                multiple
                                                value={emailRubricType}
                                                onChange={(e) => {
                                                    const values = Array.from(e.target.selectedOptions, option => option.value);

                                                    // If "All" selected -> select everything
                                                    if (values.includes("All")) {
                                                        setEmailRubricType([
                                                            "All",
                                                            ...rubricTypeAllData.map(item => item.rubricType)
                                                        ]);
                                                    } else {
                                                        setEmailRubricType(values);
                                                    }
                                                }}
                                                className='w-full border rounded px-3 py-2 outline-none focus:border-theme_sky_blue h-[200px]'
                                            >
                                                <option value="All">Full Session / All</option>

                                                {rubricTypeAllData?.map((item, index) => (
                                                    <option key={index} value={item.rubricType}>
                                                        {item.rubricType}
                                                    </option>
                                                ))}
                                            </select> */}

                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                placeholder="Search and select rubric type..."
                                                options={[
                                                    { value: "All", label: "Full Session / All" },
                                                    ...(rubricTypeAllData || []).map((item) => ({
                                                        value: item.rubricType,
                                                        label: item.rubricType
                                                    }))
                                                ]}
                                                value={emailRubricType}
                                                onChange={(selectedOptions) => {

                                                    const values = selectedOptions || [];

                                                    const hasAll = values.some(item => item.value === "All");

                                                    if (hasAll) {

                                                        const allOptions = [
                                                            { value: "All", label: "Full Session / All" },
                                                            ...(rubricTypeAllData || []).map((item) => ({
                                                                value: item.rubricType,
                                                                label: item.rubricType
                                                            }))
                                                        ];

                                                        setEmailRubricType(allOptions);

                                                    } else {

                                                        setEmailRubricType(values);

                                                    }
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: "42px",
                                                        borderRadius: "8px"
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label className='block font-semibold mb-1'>Email Content:</label>
                                            <textarea rows="4" value={emailContent} onChange={(e) => setEmailContent(e.target.value)} className='w-full border rounded px-3 py-2 outline-none focus:border-theme_sky_blue' placeholder="Dear Parents, Please review the progress..." />
                                        </div>
                                    </div>

                                    <div className='flex justify-end mt-6'>
                                        <button onClick={handleSendEmails} disabled={emailing || selectedStudents.length === 0} className={`px-[20px] py-[8px] rounded-lg text-white font-semibold ${emailing ? 'bg-gray-400 cursor-not-allowed' : 'bg-theme_green hover:bg-green-600'}`}>
                                            {emailing ? 'Sending...' : 'Send Emails'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {/* ==========email modal end===================  */}

                    {/* ==========assess modal start===================  */}
                    {
                        assessModal && assessModal ? (
                            <div>
                                <div className='inset-0 fixed top-0 left-0 w-full h-full bg-black/80 z-10 '>
                                    <div className='w-full h-full flex justify-center items-center'>

                                        <div className='w-[60%] h-auto bg-theme_yellow_light px-[20px] py-[20px]'>
                                            <div className='flex justify-between items-center mb-4 '>
                                                <h2 className='text-xl font-bold'>
                                                    Assess Students
                                                </h2>
                                                <button
                                                    className='text-gray-600 hover:text-gray-800' onClick={handleAssessModalClose}>
                                                    ✕
                                                </button>
                                            </div>

                                            <div className='flex justify-between'>
                                                <div className='left_container w-[50%]'>

                                                    <div className='w-[97%]'>



                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Student ID:</label>
                                                            </div>
                                                            <div>
                                                                <input value={selectedRow?.student_id} onChange={(e) => setstudentID(e.target.value)} className='w-full' type="text" />
                                                            </div>
                                                        </div>

                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Student Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={selectedRow?.name} onChange={(e) => setstudentName(e.target.value)} className='w-full' type="text" />
                                                            </div>
                                                        </div>



                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Class:</label>
                                                            </div>
                                                            <div>
                                                                {/* <select value={class_name} onChange={(e) => setclass_name(e.target.value)} className=' w-full ' >
                                                                    <option value="">Select Class</option>
                                                                    {
                                                                        allClassDATA && allClassDATA.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }

                                                                </select> */}

                                                                <input value={selectedRow?.classes} onChange={(e) => setstudentName(e.target.value)} className='w-full' type="text" />

                                                            </div>
                                                        </div>


                                                        <div className='hidden w-full'>
                                                            <div>
                                                                <label >Session:</label>
                                                            </div>
                                                            <div>
                                                                <select value={fetchedSession ? fetchedSession : sessionName} onChange={(e) => setsessionName(e.target.value)} className=' w-full' >
                                                                    <option value="">Select Session</option>
                                                                    {
                                                                        allSessionData && allSessionData.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                            </div>
                                                        </div>



                                                        <div className=' hidden w-full'>
                                                            <div>
                                                                <label >Month:</label>
                                                            </div>
                                                            <div>
                                                                <select value={fetchedAssessmentPeriod ? fetchedAssessmentPeriod : month_name} onChange={(e) => setmonth_name(e.target.value)} className=' w-full' >
                                                                    <option value="">Select Month</option>
                                                                    {
                                                                        allMonthsData && allMonthsData.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                            </div>
                                                        </div>


                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Rubric Type:</label>
                                                            </div>
                                                            <div>
                                                                <select value={rubric_type_skills} onChange={(e) => setrubric_type_skills(e.target.value)} className=' w-full' >
                                                                    <option value="">Select Rubric Type</option>
                                                                    {
                                                                        rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.rubricType}>{item.rubricType}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>


                                                        <div className=''>
                                                            <table className='border border-separate text-[12px]'>
                                                                <thead className=''>
                                                                    <th>Sno.</th>
                                                                    {/* <th>Class name</th> */}
                                                                    {/* <th>Month</th> */}
                                                                    <th>Skill</th>
                                                                    <th>Update Progress</th>
                                                                    {/* <th>Edit</th> */}
                                                                    {/* <th>Delete</th> */}
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        rubricSkillsAllData && rubricSkillsAllData
                                                                            .filter((item) => {
                                                                                // No filters: return all items
                                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return true;
                                                                                }
                                                                                // Only class filter
                                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes;
                                                                                }
                                                                                // Only month filter
                                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.month_name === fetchedAssessmentPeriod;
                                                                                }
                                                                                // Only rubric type filter
                                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.rubric_type === rubric_type_skills;
                                                                                }
                                                                                // Class and month filters
                                                                                if (selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.month_name === fetchedAssessmentPeriod;
                                                                                }
                                                                                // Class and rubric type filters
                                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                                // Month and rubric type filters
                                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.month_name === fetchedAssessmentPeriod &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                                // All filters
                                                                                if (selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.month_name === fetchedAssessmentPeriod &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                                return false;
                                                                            })
                                                                            .map((item, index) => {
                                                                                return (

                                                                                    <tr key={index} className='text-center border border-separate'>
                                                                                        <td>{index + 1}</td>
                                                                                        {/* <td>{item.class_name}</td> */}
                                                                                        {/* <td>{item.month_name}</td> */}
                                                                                        <td><input value={item.skill_name} type="text" readOnly /></td>
                                                                                        {/* <td><RiEditLine size={20} /></td> */}
                                                                                        {/* <td><MdDeleteForever size={20} /></td> */}
                                                                                        <td>
                                                                                            <select
                                                                                                value={skillAnswers[item.skill_name] || ""}
                                                                                                onChange={(e) => handleSkillAnswerChange(item.skill_name, e.target.value)}
                                                                                                className='text-[10px]'

                                                                                            >
                                                                                                <option value="">Select Progress</option>
                                                                                                {
                                                                                                    getAllJudgeCriteria && getAllJudgeCriteria.map((item, index) => {
                                                                                                        return (
                                                                                                            <Fragment key={index}>
                                                                                                                <option value={item.name}>{item.name}</option>
                                                                                                            </Fragment>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </div>

                                                        <div className='w-full mt-[10px] flex justify-between items-center'>

                                                            <div className='flex justify-end gap-3'>
                                                                <p>Rate Student : </p>
                                                                {
                                                                    stars && stars.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <FaStar
                                                                                    key={index}
                                                                                    value={item.val}
                                                                                    onClick={() => handleFillStar(item.val)}
                                                                                    size={20}
                                                                                    color={item.val <= star ? '#ff40b8' : '#e4e5e9'}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                                <button onClick={() => setstar(0)} className='bg-theme_sky_blue px-[8px] py-[2px] text-white rounded-xl' >Clear</button>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>


                                                <div className='right_container w-[50%]'>
                                                    <div className='w-[97%]'>
                                                        {/* <div className=''>
                                                            <table className='border border-separate text-[12px]'>
                                                                <thead className=''>
                                                                    <th>Sno.</th>
                                                               
                                                                    <th>Skill</th>
                                                                    <th>Update Progress</th>
                                                                 
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        rubricSkillsAllData && rubricSkillsAllData
                                                                            .filter((item) => {
                                                                            
                                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return true;
                                                                                }
                                                                              
                                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes;
                                                                                }
                                                                              
                                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.month_name === fetchedAssessmentPeriod;
                                                                                }
                                                                             
                                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.rubric_type === rubric_type_skills;
                                                                                }
                                                                              
                                                                                if (selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.month_name === fetchedAssessmentPeriod;
                                                                                }
                                                                               
                                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                               
                                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.month_name === fetchedAssessmentPeriod &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                               
                                                                                if (selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                                    return item.class_name === selectedRow.classes &&
                                                                                        item.month_name === fetchedAssessmentPeriod &&
                                                                                        item.rubric_type === rubric_type_skills;
                                                                                }
                                                                                return false;
                                                                            })
                                                                            .map((item, index) => {
                                                                                return (

                                                                                    <tr key={index} className='text-center border border-separate'>
                                                                                        <td>{index + 1}</td>
                                                                                       
                                                                                        <td><input value={item.skill_name} type="text" readOnly /></td>
                                                                                      
                                                                                        <td>
                                                                                            <select
                                                                                                value={skillAnswers[item.skill_name] || ""}
                                                                                                onChange={(e) => handleSkillAnswerChange(item.skill_name, e.target.value)}
                                                                                                className='text-[10px]'

                                                                                            >
                                                                                                <option value="">Select Progress</option>
                                                                                                {
                                                                                                    getAllJudgeCriteria && getAllJudgeCriteria.map((item, index) => {
                                                                                                        return (
                                                                                                            <Fragment key={index}>
                                                                                                                <option value={item.name}>{item.name}</option>
                                                                                                            </Fragment>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </div>

                                                        <div className='w-full mt-[10px] '>
                                                            <div className='flex justify-end gap-3'>
                                                                {
                                                                    stars && stars.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <FaStar
                                                                                    key={index}
                                                                                    value={item.val}
                                                                                    onClick={() => handleFillStar(item.val)}
                                                                                    size={20}
                                                                                    color={item.val <= star ? '#ff40b8' : '#e4e5e9'}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </div>

                                                        </div> */}

                                                        <div className='w-full'>
                                                            {/* <div>
                                                                <label >Notes/Comments:</label>
                                                            </div>
                                                            <div>
                                                                <input value={comments} onChange={(e) => setcomments(e.target.value)} className='w-full' type="text" />
                                                            </div> */}
                                                        </div>
                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Suggestion for parents:</label>
                                                            </div>
                                                            <div>
                                                                <input value={suggestionForParents} onChange={(e) => setsuggestionForParents(e.target.value)} className='w-full' type="text" />
                                                            </div>
                                                        </div>
                                                        <div className='w-full'>
                                                            <div>
                                                                <label >Reference URL:</label>
                                                            </div>
                                                            <div>
                                                                <input value={reference_url} onChange={(e) => setreference_url(e.target.value)} className='w-full' type="text" />
                                                            </div>
                                                        </div>

                                                        <div className='flex justify-end gap-3 mt-4'>
                                                            <button onClick={() => setshowPreviewModal(true)} className='bg-theme_blue px-[20px] py-[5px] rounded-3xl text-theme_white'>Preview</button>
                                                            {/* <button onClick={() => handleSaveStudentData(assessdModalId)} className='bg-theme_green px-[20px] py-[5px] rounded-3xl text-theme_white'>Save</button> */}
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                    </div>



                                </div>
                            </div>
                        ) : null
                    }
                    {/* ==========assess modal end===================  */}





                    {/* ============preview modal start==============  */}
                    {showPreviewModal && (
                        <div className='inset-0 fixed top-0 left-0 w-full h-full bg-black/80 z-20 flex items-center justify-center'>
                            <div className='w-[90%] md:w-[80%] lg:w-[70%] h-auto max-h-[90vh] bg-white rounded-lg overflow-y-auto'>
                                <div className='sticky top-0 bg-theme_yellow_light px-[20px] py-[15px] flex justify-between items-center border-b border-gray-300'>
                                    <h2 className='text-xl font-bold'>Assessment Preview</h2>
                                    <button
                                        onClick={() => setshowPreviewModal(false)}
                                        className='text-gray-600 hover:text-gray-800 text-2xl'
                                    >
                                        ✕
                                    </button>
                                </div>

                                <div className='p-[20px]'>
                                    {/* Student Basic Information */}
                                    <div className='mb-6'>
                                        <h3 className='text-lg font-bold text-theme_sky_blue mb-3'>Student Information</h3>
                                        <div className='grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg'>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Student ID:</label>
                                                <p className='text-gray-600'>{selectedRow?.student_id || 'N/A'}</p>
                                            </div>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Student Name:</label>
                                                <p className='text-gray-600'>{selectedRow?.name || 'N/A'}</p>
                                            </div>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Class:</label>
                                                <p className='text-gray-600'>{selectedRow?.classes || 'N/A'}</p>
                                            </div>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Section:</label>
                                                <p className='text-gray-600'>{selectedRow?.section || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Assessment Details */}
                                    <div className='mb-6'>
                                        <h3 className='text-lg font-bold text-theme_sky_blue mb-3'>Assessment Details</h3>
                                        <div className='grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg'>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Rubric Type:</label>
                                                <p className='text-gray-600'>{rubric_type_skills || 'N/A'}</p>
                                            </div>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Rating:</label>
                                                <p className='text-gray-600'>{'⭐'.repeat(star)} {star > 0 ? `(${star}/3)` : 'No rating'}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Skills Assessment */}
                                    <div className='mb-6'>
                                        <h3 className='text-lg font-bold text-theme_sky_blue mb-3'>Skills Assessment</h3>
                                        <div className='overflow-x-auto'>
                                            <table className='w-full border-collapse'>
                                                <thead>
                                                    <tr className='bg-theme_sky_blue text-white'>
                                                        <th className='border border-gray-300 px-4 py-2 text-left'>S.No</th>
                                                        <th className='border border-gray-300 px-4 py-2 text-left'>Skill Name</th>
                                                        <th className='border border-gray-300 px-4 py-2 text-center'>Progress</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        rubricSkillsAllData && rubricSkillsAllData
                                                            .filter((item) => {
                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                    return true;
                                                                }
                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                    return item.class_name === selectedRow.classes;
                                                                }
                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                    return item.month_name === fetchedAssessmentPeriod;
                                                                }
                                                                if (!selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                    return item.rubric_type === rubric_type_skills;
                                                                }
                                                                if (selectedRow.classes && fetchedAssessmentPeriod && !rubric_type_skills) {
                                                                    return item.class_name === selectedRow.classes &&
                                                                        item.month_name === fetchedAssessmentPeriod;
                                                                }
                                                                if (selectedRow.classes && !fetchedAssessmentPeriod && rubric_type_skills) {
                                                                    return item.class_name === selectedRow.classes &&
                                                                        item.rubric_type === rubric_type_skills;
                                                                }
                                                                if (!selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                    return item.month_name === fetchedAssessmentPeriod &&
                                                                        item.rubric_type === rubric_type_skills;
                                                                }
                                                                if (selectedRow.classes && fetchedAssessmentPeriod && rubric_type_skills) {
                                                                    return item.class_name === selectedRow.classes &&
                                                                        item.month_name === fetchedAssessmentPeriod &&
                                                                        item.rubric_type === rubric_type_skills;
                                                                }
                                                                return false;
                                                            })
                                                            .map((item, index) => (
                                                                <tr key={index} className='hover:bg-gray-100 transition-colors'>
                                                                    <td className='border border-gray-300 px-4 py-2'>{index + 1}</td>
                                                                    <td className='border border-gray-300 px-4 py-2'>{item.skill_name}</td>
                                                                    <td className='border border-gray-300 px-4 py-2 text-center'>
                                                                        <span className={`px-3 py-1 rounded text-white text-sm font-semibold ${skillAnswers[item.skill_name] === 'ACHIEVED' ? 'bg-green-500' :
                                                                            skillAnswers[item.skill_name] === 'DEVELOPING' ? 'bg-yellow-500' :
                                                                                skillAnswers[item.skill_name] === 'NOT ACHIEVED' ? 'bg-red-500' :
                                                                                    'bg-gray-400'
                                                                            }`}>
                                                                            {skillAnswers[item.skill_name] || 'Not Selected'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* Comments and Additional Info */}
                                    <div className='mb-6'>
                                        <h3 className='text-lg font-bold text-theme_sky_blue mb-3'>Additional Information</h3>
                                        <div className='space-y-3 bg-gray-50 p-4 rounded-lg'>
                                            {/* <div>
                                                <label className='font-semibold text-gray-700'>Notes/Comments:</label>
                                                <p className='text-gray-600 mt-1 p-2 bg-white rounded border border-gray-200'>{comments || 'No comments'}</p>
                                            </div> */}
                                            <div>
                                                <label className='font-semibold text-gray-700'>Suggestion for Parents:</label>
                                                <p className='text-gray-600 mt-1 p-2 bg-white rounded border border-gray-200'>{suggestionForParents || 'No suggestions'}</p>
                                            </div>
                                            <div>
                                                <label className='font-semibold text-gray-700'>Reference URL:</label>
                                                {reference_url ? (
                                                    <a
                                                        href={reference_url}
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                        className='text-blue-500 hover:underline mt-1 block p-2 bg-white rounded border border-gray-200'
                                                    >
                                                        {reference_url}
                                                    </a>
                                                ) : (
                                                    <p className='text-gray-600 mt-1 p-2 bg-white rounded border border-gray-200'>No URL provided</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className='flex justify-end gap-3 pt-4 border-t border-gray-300'>
                                        <button
                                            onClick={() => setshowPreviewModal(false)}
                                            className='bg-gray-500 hover:bg-gray-600 px-[20px] py-[8px] rounded-3xl text-white transition-colors'
                                        >
                                            Back to Edit
                                        </button>
                                        <button
                                            onClick={() => {
                                                handleSaveStudentData(assessdModalId);
                                                setshowPreviewModal(false);
                                            }}
                                            className='bg-theme_green hover:bg-green-600 px-[20px] py-[8px] rounded-3xl text-white transition-colors'
                                        >
                                            Confirm & Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* ============preview modal end==============  */}




                    {/* ===========reset student data modal start ==============  */}
                    {
                        showResetRubricModal && (
                            <div className='inset-0 fixed top-0 left-0 w-full h-full bg-black/80 z-20 flex items-center justify-center'>
                                <div className='w-[70%] h-auto bg-white rounded-lg p-6'>
                                    <div className='flex justify-between items-center'>
                                        <h2 className='text-xl font-bold mb-4'>Reset Student Assessment Data</h2>
                                        <button
                                            className='text-gray-600 hover:text-gray-800'
                                            onClick={closeResetModal}>
                                            ✕
                                        </button>
                                    </div>
                                    <p className='mb-6'>Are you sure you want to reset the assessment data for <span className='font-semibold'>{resetStudentName}</span>? This action cannot be undone.</p>
                                    <p>Filter data based on session,month and Rubric type</p>
                                    <div className='flex justify-start gap-3 py-[10px]'>
                                        <select value={fetchedSession} disabled >
                                            <option value="">Select Session</option>
                                            {
                                                allSessionData && allSessionData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.name}>{item.name}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }

                                        </select>
                                        <select className='' value={resetRubricMonth} onChange={resetSearchHandler} >
                                            <option value="">Select Month</option>
                                            {
                                                allMonthsData && allMonthsData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.name}>{item.name}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className='' onChange={handleRubricTypeChange} value={resetRubricType} >
                                            <option value="">Select Rubric Type</option>
                                            {
                                                rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.rubricType}>{item.rubricType}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>

                                    {resetAllData && !resetLoading && !error && (
                                        <div className="max-h-[270px] overflow-y-scroll pb-[20px] print:overflow-visible print:h-auto scrollable_area">
                                            {filteredRubricData.length === 0 ? (
                                                <p className="text-center text-gray-600 text-sm">No data</p>
                                            ) : (
                                                // If your groupRubricData expects the full list and groups by month/session,
                                                // pass displayRubrics to it:
                                                groupRubricData(filteredRubricData)
                                                    .map((group, groupIndex) => (
                                                        <div key={groupIndex} className="border border-gray-200 rounded-lg p-3 bg-gray-50 print:border-gray-400">
                                                            <div className='flex justify-between'>
                                                                <h3 className="text-sm 2xl:text-lg font-semibold mb-2 text-gray-700">
                                                                    {group.month} ({group.session})
                                                                </h3>

                                                                <div>
                                                                    {/* Option A: delete whole month (requires API call per rubric entry — but your backend deletes by both month & type,
                    so deleting whole month isn't a single call unless you loop) */}

                                                                    {/* Option B: better UX — show delete per rubric entry (see below) */}
                                                                </div>
                                                            </div>

                                                            {group.rubrics.map((rubric, index) => (
                                                                <div key={index} className="p-2 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow duration-300 mb-2 print:shadow-none print:border-gray-400">
                                                                    <div className="disFlexJCIC flex justify-between items-center mb-2 2xl:mb-4">
                                                                        <h4 className="text-[11px] 2xl:text-md font-medium text-gray-800">{(rubric.rubric_type || rubric.rubricType).toUpperCase()}</h4>
                                                                        <div className="flex items-center gap-2">
                                                                            <div>
                                                                                <span className="text-yellow-500 mr-1 print:text-black">Stars:</span>
                                                                                {'⭐'.repeat(rubric.star || 0)}
                                                                            </div>

                                                                            {/* DELETE ICON -> call handleResetRubric with proper args */}
                                                                            <button
                                                                                onClick={() => handleResetRubric(
                                                                                    // student id: use resetAllData._id or resetAllData._id.$oid as needed
                                                                                    resetAllData._id?.$oid ?? resetAllData._id ?? resetAllData.id ?? resetStudentId,
                                                                                    rubric.month ?? rubric.rubric_month ?? group.month,
                                                                                    rubric.rubric_type ?? rubric.rubricType,
                                                                                    rubric._id
                                                                                )}
                                                                                className="text-red-600 hover:text-red-800"
                                                                                title={`Reset ${rubric.rubric_type ?? rubric.rubricType} (${rubric.month ?? rubric.rubric_month})`}
                                                                            >
                                                                                <MdDeleteForever size={20} />
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    {/* rest of rubric content (skills table, comments, etc.) unchanged */}
                                                                    {/* Skills Table */}
                                                                    <h5 className="text-sm font-semibold mb-1 text-gray-700">Skills</h5>
                                                                    <div className="overflow-x-auto print:overflow-visible">
                                                                        <table className="min-w-full table-auto border-collapse border border-gray-300">
                                                                            <thead className="bg-gray-100 print:bg-white">
                                                                                <tr>
                                                                                    <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Skill Name</th>
                                                                                    <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Status</th>
                                                                                    {/* <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Updated On</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {rubric.rubric_skills?.map((skill, sIndex) => (
                                                                                    <tr key={sIndex} className="hover:bg-gray-50 transition-colors duration-200 print:hover:bg-white">
                                                                                        <td className="px-4 py-2 border border-gray-300 text-sm">{skill.skill_name || 'N/A'}</td>
                                                                                        <td className="px-4 py-2 border border-gray-300 text-sm status">
                                                                                            <span
                                                                                                className={`px-2 py-1 rounded text-white print:text-black print:bg-gray-200 ${skill.skill_answer === 'ACHIEVED'
                                                                                                    ? 'bg-green-500'
                                                                                                    : skill.skill_answer === 'DEVELOPING'
                                                                                                        ? 'bg-yellow-500'
                                                                                                        : 'bg-red-500'
                                                                                                    }`}
                                                                                            >
                                                                                                {skill.skill_answer || 'N/A'}
                                                                                            </span>
                                                                                        </td>
                                                                                        {/* <td className="px-4 py-2 border border-gray-300 text-sm">{skill.updated_on ? parseDate(skill.updated_on) : 'N/A'}</td> */}
                                                                                    </tr>
                                                                                )) || <tr><td colSpan="3" className="px-4 py-2 text-center text-sm">No skills available</td></tr>}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* Additional Details */}
                                                                    <div className="mt-4 space-y-2">
                                                                        {/* <p className="text-gray-600 text-sm"><span className="font-medium">Comments:</span> {rubric.comments || 'N/A'}</p> */}
                                                                        <p className="text-gray-600 text-sm"><span className="font-medium">Parents Suggestion:</span> {rubric.parents_suggestion || 'N/A'}</p>
                                                                        <p className="text-gray-600 text-sm">
                                                                            <span className="font-medium">Reference URL:</span>
                                                                            <a
                                                                                href={rubric.reference_url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="text-blue-500 hover:underline ml-1 print:text-black print:no-underline"
                                                                            >
                                                                                {rubric.reference_url || 'N/A'}
                                                                            </a>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>


                        )
                    }
                    {/* ===========reset student data modal end ==============  */}



                    {/* ===========update student modal start ==============  */}
                    {
                        updateModal && (
                            <div className='inset-0 fixed top-0 left-0 w-full h-full bg-black/80 z-20 flex items-center justify-center'>
                                <div className='w-[70%] h-auto bg-white rounded-lg p-6'>
                                    <div className='flex justify-between items-center'>
                                        <h2 className='text-xl font-bold mb-4'>Update Student Assessment Data</h2>
                                        <button
                                            className='text-gray-600 hover:text-gray-800'
                                            onClick={closeUpdateModal}>
                                            ✕
                                        </button>
                                    </div>
                                    <p className='mb-6'>Are you sure you want to udpate the assessment data for <span className='font-semibold'>{updateStudentName}</span>?</p>
                                    <p>Filter data based on session,month and Rubric type</p>
                                    <div className='flex justify-start gap-3 py-[10px]'>
                                        <select value={fetchedSession} disabled >
                                            <option value="">Select Session</option>
                                            {
                                                allSessionData && allSessionData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.name}>{item.name}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }

                                        </select>

                                        <select className='' value={updateStudentMonth} onChange={updateMonthFilterHandler} >
                                            <option value="">Select Month</option>
                                            {
                                                allMonthsData && allMonthsData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.name}>{item.name}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </select>

                                        <select className='' onChange={updateRubricTypeChangeHandler} value={updateStudentRubricType} >
                                            <option value="">Select Rubric Type</option>
                                            {
                                                rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.rubricType}>{item.rubricType}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </select>

                                    </div>



                                    {/* {
                                        updateAllData &&  ( */}
                                    {/* skills display start  */}
                                    <div className="max-h-[270px] overflow-y-scroll pb-[20px] print:overflow-visible print:h-auto scrollable_area">
                                        {!updateStudentMonth || !updateStudentRubricType ? (
                                            <div className="text-center py-10 text-gray-500">
                                                <p className="text-lg">Please select both <strong>Month</strong> and <strong>Rubric Type</strong> to view and edit skills.</p>
                                            </div>
                                        ) : filteredUpdateRubricData.length === 0 ? (
                                            <div className="text-center py-10 text-gray-500">
                                                <p>No assessment data found for the selected month and rubric type.</p>
                                            </div>
                                        ) : (
                                            groupRubricData(filteredUpdateRubricData)
                                                .map((group, groupIndex) => (
                                                    <div key={groupIndex} className="border border-gray-200 rounded-lg p-3 bg-gray-50 print:border-gray-400">
                                                        <div className='flex justify-between'>
                                                            <h3 className="text-sm 2xl:text-lg font-semibold mb-2 text-gray-700">
                                                                {group.month} ({group.session})
                                                            </h3>

                                                            <div>
                                                                {/* Option A: delete whole month (requires API call per rubric entry — but your backend deletes by both month & type,
                                                                 so deleting whole month isn't a single call unless you loop) */}

                                                                {/* Option B: better UX — show delete per rubric entry (see below) */}
                                                            </div>
                                                        </div>

                                                        {group.rubrics.map((rubric, index) => (
                                                            <div key={index} className="p-2 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow duration-300 mb-2 print:shadow-none print:border-gray-400">
                                                                <div className="disFlexJCIC flex justify-between items-center mb-2 2xl:mb-4">
                                                                    <h4 className="text-[11px] 2xl:text-md font-medium text-gray-800">{(rubric.rubric_type || rubric.rubricType).toUpperCase()}</h4>
                                                                    <div className="flex items-center gap-2">
                                                                        <div>
                                                                            {/* <span className="text-yellow-500 mr-1 print:text-black">Stars:</span>
                                                                            {'⭐'.repeat(rubric.star || 0)} */}

                                                                            {/* Select */}
                                                                            <select
                                                                                value={updatestarRating}
                                                                                onChange={(e) => setupdatestarRating(Number(e.target.value))}
                                                                                className="border rounded-md px-2 py-1 text-sm focus:ring-1 focus:ring-blue-500"
                                                                            >
                                                                                <option value={0}>Select</option>
                                                                                <option value={1}>1 Star</option>
                                                                                <option value={2}>2 Stars</option>
                                                                                <option value={3}>3 Stars</option>
                                                                            </select>

                                                                            {/* Star Preview */}
                                                                            <div className="flex gap-1 text-xl">
                                                                                {'⭐'.repeat(updatestarRating)}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                {/* rest of rubric content (skills table, comments, etc.) unchanged */}
                                                                {/* Skills Table */}
                                                                <h5 className="text-sm font-semibold mb-1 text-gray-700">Skills</h5>
                                                                <div className="overflow-x-auto print:overflow-visible">
                                                                    <table className="min-w-full table-auto border-collapse border border-gray-300">
                                                                        <thead className="bg-gray-100 print:bg-white">
                                                                            <tr>
                                                                                <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Skill Name</th>
                                                                                <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Status</th>
                                                                                {/* <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Updated On</th> */}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {rubric.rubric_skills?.map((skill, sIndex) => (
                                                                                <tr key={sIndex} className="hover:bg-gray-50 transition-colors duration-200 print:hover:bg-white">
                                                                                    <td className="px-4 py-2 border border-gray-300 text-sm">{skill.skill_name || 'N/A'}</td>
                                                                                    <td className="px-4 py-2 border border-gray-300 text-sm status">
                                                                                        <select
                                                                                            // className={`px-2 py-1 rounded text-white print:text-black print:bg-gray-200 ${skill.skill_answer === 'ACHIEVED'
                                                                                            //     ? 'bg-green-500'
                                                                                            //     : skill.skill_answer === 'DEVELOPING'
                                                                                            //         ? 'bg-yellow-500'
                                                                                            //         : 'bg-red-500'
                                                                                            //     }`}
                                                                                            // value={skill.skill_answer || 'N/A'}
                                                                                            // onChange={(e) => handleupdateSkillAnswerChange(skill._id, skill.rubric_month, e.target.value)}
                                                                                            value={getCurrentValue(skill)}
                                                                                            onChange={(e) => handleSkillChange(skill._id?.$oid || skill._id, e.target.value)}
                                                                                            className={`px-3 py-1 rounded border ${hasChanged(skill) ? 'bg-yellow-100 border-yellow-500 font-semibold' : 'border-gray-300'
                                                                                                }`}

                                                                                        >
                                                                                            {getAllJudgeCriteria &&
                                                                                                getAllJudgeCriteria.map((criteria, index) => (
                                                                                                    <option key={index} value={criteria.name}>{criteria.name}</option>
                                                                                                ))
                                                                                            }

                                                                                        </select>
                                                                                    </td>
                                                                                    {/* <td className="px-4 py-2 border border-gray-300 text-sm">{skill.updated_on ? parseDate(skill.updated_on) : 'N/A'}</td> */}
                                                                                </tr>
                                                                            )) || <tr><td colSpan="3" className="px-4 py-2 text-center text-sm">No skills available</td></tr>}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                {/* Additional Details */}
                                                                <div className="mt-4 space-y-2">
                                                                    {/* <p className="text-gray-600 text-sm"><span className="font-medium">Comments:</span> {rubric.comments || 'N/A'}</p> */}
                                                                    {/* <p className="text-gray-600 text-sm"><span className="font-medium">Parents Suggestion:</span> {rubric.parents_suggestion || 'N/A'}</p> */}
                                                                    <div>
                                                                        <label className="text-sm font-medium text-gray-700">
                                                                            Parents Suggestion
                                                                        </label>
                                                                        <textarea
                                                                            value={parentsSuggestion}
                                                                            onChange={(e) => setParentsSuggestion(e.target.value)}
                                                                            rows={3}
                                                                            className="w-full mt-1 border rounded-md p-2 text-sm focus:ring-1 focus:ring-blue-500"
                                                                            placeholder="Enter suggestion for parents"
                                                                        />
                                                                    </div>

                                                                    {/* <p className="text-gray-600 text-sm">
                                                                        <span className="font-medium">Reference URL:</span>
                                                                        <a
                                                                            href={rubric.reference_url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-blue-500 hover:underline ml-1 print:text-black print:no-underline"
                                                                        >
                                                                            {rubric.reference_url || 'N/A'}
                                                                        </a>
                                                                    </p> */}

                                                                    {/* Reference URL */}
                                                                    <div>
                                                                        <label className="text-sm font-medium text-gray-700">
                                                                            Reference URL
                                                                        </label>
                                                                        <input
                                                                            type="url"
                                                                            value={referenceUrl}
                                                                            onChange={(e) => setReferenceUrl(e.target.value)}
                                                                            className="w-full mt-1 border rounded-md p-2 text-sm focus:ring-1 focus:ring-blue-500"
                                                                            placeholder="https://example.com"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))
                                        )
                                        }
                                    </div>
                                    {/* skills display start  */}
                                    {/* )
                                        }
                                   */}




                                    <div className="mt-6 flex justify-end gap-4">
                                        <button
                                            onClick={closeUpdateModal}
                                            className="px-6 py-2 border border-gray-400 rounded-lg hover:bg-gray-100"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            onClick={handleSaveAllChanges}
                                            // disabled={Object.keys(skillChanges).length === 0}
                                            className={`px-8 py-2 rounded-lg text-white font-medium transition  bg-blue-600 hover:bg-blue-700   `

                                                // ${Object.keys(skillChanges).length === 0
                                                //     ?
                                                //     'bg-gray-400 cursor-not-allowed'
                                                //     :
                                                //     'bg-blue-600 hover:bg-blue-700'
                                                // }

                                            }
                                        >
                                            Save All Changes ({Object.keys(skillChanges).length})
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )

                    }


                    {/* ===========update student modal end ==============  */}



                    {/* =====================report card start==========================  */}
                    {showReportCard && (
                        // <div className="fixed inset-0 top-0 left-0 w-full h-full bg-black/80 z-10 flex items-center justify-center">
                        //     <div className= " h-[80vh] overflow-hidden container mx-auto p-6 bg-white shadow-lg rounded-lg max-w-4xl relative">
                        //         {/* Close Button */}
                        //         <button
                        //             onClick={() => setShowReportCard(false)}
                        //             className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                        //         >
                        //             ✕
                        //         </button>

                        //         {loading && <p className="text-center text-gray-600">Loading...</p>}
                        //         {error && <p className="text-center text-red-500">{error}</p>}
                        //         {reportData && !loading && !error && (
                        //             < >
                        //                 <h1 className="text-3xl font-bold text-center mb-6 text-gray-800">Student Report Card</h1>

                        //                 {/* Student Information Section */}
                        //                 <div className="mb-8 p-4 border border-gray-200 rounded-lg bg-gray-50">
                        //                     <h2 className="text-xl font-semibold mb-4 text-gray-700">Student Details</h2>
                        //                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        //                         <p className="text-gray-600"><span className="font-medium">Name:</span> {reportData.name}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">Student ID:</span> {reportData.student_id}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">Class:</span> {reportData.classes} - {reportData.section}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">Session:</span> {reportData.session}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">School Location:</span> {reportData.school_location}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">Teacher:</span> {reportData.teacher_name}</p>
                        //                         <p className="text-gray-600"><span className="font-medium">Last Updated:</span> {parseDate(reportData.updatedAt)}</p>
                        //                     </div>
                        //                 </div>

                        //                 {/* Rubric Data Section */}
                        //                 <h2 className="text-2xl font-semibold mb-6 text-gray-800 ">Rubric Assessments</h2>


                        //                 <div className="space-y-6  overflow-y-scroll pb-[40px]" style={{ maxHeight: '400px' }}>
                        //                     {reportData.rubric_data?.map((rubric, index) => (
                        //                         <div key={index} className="p-6 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow duration-300">
                        //                             <div className="flex justify-between items-center mb-4">
                        //                                 <h3 className="text-lg font-medium text-gray-800">
                        //                                     {rubric.month} ({rubric.session}) - {rubric.rubric_type.toUpperCase()}
                        //                                 </h3>
                        //                                 <div className="flex items-center">
                        //                                     <span className="text-yellow-500 mr-1">Stars:</span>
                        //                                     {'⭐'.repeat(rubric.star)}
                        //                                 </div>
                        //                             </div>

                        //                             {/* Skills Table */}
                        //                             <h4 className="text-md font-semibold mb-2 text-gray-700">Skills</h4>
                        //                             <div className="overflow-x-auto">
                        //                                 <table className="min-w-full table-auto border-collapse border border-gray-300">
                        //                                     <thead className="bg-gray-100">
                        //                                         <tr>
                        //                                             <th className="px-4 py-2 text-left text-gray-600 border border-gray-300">Skill Name</th>
                        //                                             <th className="px-4 py-2 text-left text-gray-600 border border-gray-300">Status</th>
                        //                                             <th className="px-4 py-2 text-left text-gray-600 border border-gray-300">Updated On</th>
                        //                                         </tr>
                        //                                     </thead>
                        //                                     <tbody>
                        //                                         {rubric.rubric_skills?.map((skill, sIndex) => (
                        //                                             <tr key={sIndex} className="hover:bg-gray-50 transition-colors duration-200">
                        //                                                 <td className="px-4 py-2 border border-gray-300">{skill.skill_name}</td>
                        //                                                 <td className="px-4 py-2 border border-gray-300">
                        //                                                     <span
                        //                                                         className={`px-2 py-1 rounded text-white ${skill.skill_answer === 'ACHIEVED' ? 'bg-green-500' : 'bg-yellow-500'
                        //                                                             }`}
                        //                                                     >
                        //                                                         {skill.skill_answer}
                        //                                                     </span>
                        //                                                 </td>
                        //                                                 <td className="px-4 py-2 border border-gray-300">{parseDate(skill.updated_on)}</td>
                        //                                             </tr>
                        //                                         ))}
                        //                                     </tbody>
                        //                                 </table>
                        //                             </div>

                        //                             {/* Additional Details */}
                        //                             <div className="mt-4 space-y-2">
                        //                                 <p className="text-gray-600"><span className uczni="font-medium">Comments:</span> {rubric.comments}</p>
                        //                                 <p className="text-gray-600"><span className="font-medium">Parents Suggestion:</span> {rubric.parents_suggestion}</p>
                        //                                 <p className="text-gray-600">
                        //                                     <span className="font-medium">Reference URL:</span>
                        //                                     <a
                        //                                         href={rubric.reference_url}
                        //                                         target="_blank"
                        //                                         rel="noopener noreferrer"
                        //                                         className="text-blue-500 hover:underline ml-1"
                        //                                     >
                        //                                         {rubric.reference_url}
                        //                                     </a>
                        //                                 </p>
                        //                             </div>
                        //                         </div>
                        //                     ))}
                        //                 </div>

                        //             </>
                        //         )}
                        //     </div>
                        // </div>



                        //===== new report card start ========
                        <div className="fixed inset-0 top-0 left-0 w-full h-full bg-black/80 z-10 flex items-center justify-center print:bg-white print:flex print:items-start">



                            <div id={`printable`} className="h-auto overflow-hidden container mx-auto p-6 bg-white shadow-lg rounded-lg max-w-4xl relative print:h-auto print:shadow-none print:rounded-none print:max-w-none">
                                <button
                                    onClick={() => setShowReportCard(false)}
                                    className="closeReportCard absolute top-4 right-4 text-gray-600 hover:text-gray-800 print:hidden"
                                >
                                    ✕
                                </button>


                                {loading && <p className="text-center text-gray-600">Loading...</p>}
                                {error && <p className="text-center text-red-500">{error}</p>}
                                {reportData && !loading && !error && (
                                    <>
                                        <div className="logo_container flex justify-between items-center px-[20px] mb-2 2xl:mb-4">
                                            <img className="logo w-[80px] h-[80px] 2xl:w-[100px] 2xl:h-[100px] " src={Logo_school} alt="school logo" />
                                            <h2>Seth Anandram jaipuria school, {userData.school_location}</h2>
                                        </div>
                                        <h1 className="text-xl 2xl:text-3xl font-bold text-center mb-2 2xl:mb-4 text-gray-800">Literacy And Numeracy Assessment</h1>

                                        {/* Student Information Section */}
                                        <div className="mb-4 p-2 border border-gray-200 rounded-lg bg-gray-50 print:border-gray-400">
                                            <h2 className="text-lg 2xl:text-xl font-semibold mb-2 text-gray-700">Student Details</h2>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1 2xl:gap-2">
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Name:</span> {reportData.name || 'N/A'}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Student ID:</span> {reportData.student_id || 'N/A'}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Class:</span> {reportData.classes} - {reportData.section || 'N/A'}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Session:</span> {reportData.session || 'N/A'}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">School Location:</span> {reportData.school_location || 'N/A'}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Teacher:</span> {getTeacherDisplayName(reportData.teacher_name)}</p>
                                                <p className="text-gray-600 text-[11px] 2xl:text-sm"><span className="font-medium">Last Updated:</span> {reportData.updatedAt ? parseDate(reportData.updatedAt) : 'N/A'}</p>
                                            </div>
                                        </div>

                                        {/* Rubric Assessments Section */}
                                        <div className="flex justify-between">
                                            <h2 className="text-lg 2xl:text-xl font-semibold mb-2 text-gray-800">Rubric Assessments</h2>
                                            <div>
                                                <select className='text-[12px]' value={filterReportMonths} onChange={(e) => setfilterReportMonths(e.target.value)} >
                                                    <option value="">Select month to filter</option>
                                                    {
                                                        allMonthsData && allMonthsData.map((item, index) => {
                                                            return (
                                                                <option value={item.name}>{item.name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div>

                                                    <button
                                                        // onClick={handlePrint}
                                                        onClick={handleDownloadPDF}
                                                        className=" text-gray-600 hover:text-gray-800 print:hidden"
                                                    >
                                                        📄 Export PDF
                                                    </button>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="max-h-[270px] overflow-y-scroll  pb-[20px]  print:overflow-visible print:h-auto scrollable_area" >
                                            {reportData.rubric_data && Array.isArray(reportData.rubric_data) ? (
                                                groupRubricData(reportData.rubric_data)
                                                    .filter((filterGroup) => {
                                                        if (!filterReportMonths) {
                                                            return filterGroup
                                                        }
                                                        else if (filterReportMonths) {
                                                            return filterGroup.month === filterReportMonths
                                                        }
                                                    })
                                                    .map((group, groupIndex) => (
                                                        <div key={groupIndex} className="border border-gray-200 rounded-lg p-3 bg-gray-50 print:border-gray-400">
                                                            <h3 className="text-sm 2xl:text-lg font-semibold mb-2 text-gray-700">
                                                                {group.month} ({group.session})
                                                            </h3>
                                                            {group.rubrics.map((rubric, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="p-2 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow duration-300 mb-2 print:shadow-none print:border-gray-400"
                                                                >
                                                                    <div className="disFlexJCIC flex justify-between items-center mb-2 2xl:mb-4">
                                                                        <h4 className="text-[11px] 2xl:text-md font-medium text-gray-800">{rubric.rubric_type.toUpperCase()}</h4>
                                                                        <div className="flex items-center">
                                                                            <span className="text-yellow-500 mr-1 print:text-black">Stars:</span>
                                                                            {'⭐'.repeat(rubric.star || 0)}
                                                                        </div>
                                                                    </div>

                                                                    {/* Skills Table */}
                                                                    <h5 className="text-sm font-semibold mb-1 text-gray-700">Skills</h5>
                                                                    <div className="overflow-x-auto print:overflow-visible">
                                                                        <table className="min-w-full table-auto border-collapse border border-gray-300">
                                                                            <thead className="bg-gray-100 print:bg-white">
                                                                                <tr>
                                                                                    <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Skill Name</th>
                                                                                    <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Status</th>
                                                                                    {/* <th className="px-2 2xl:px-4  py-2 text-left text-gray-600 border border-gray-300 text-sm">Updated On</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {rubric.rubric_skills?.map((skill, sIndex) => (
                                                                                    <tr key={sIndex} className="hover:bg-gray-50 transition-colors duration-200 print:hover:bg-white">
                                                                                        <td className="px-4 py-2 border border-gray-300 text-sm">{skill.skill_name || 'N/A'}</td>
                                                                                        <td className="px-4 py-2 border border-gray-300 text-sm status">
                                                                                            <span
                                                                                                className={`px-2 py-1 rounded text-white print:text-black print:bg-gray-200 ${skill.skill_answer === 'ACHIEVED'
                                                                                                    ? 'bg-green-500'
                                                                                                    : skill.skill_answer === 'DEVELOPING'
                                                                                                        ? 'bg-yellow-500'
                                                                                                        : 'bg-red-500'
                                                                                                    }`}
                                                                                            >
                                                                                                {skill.skill_answer || 'N/A'}
                                                                                            </span>
                                                                                        </td>
                                                                                        {/* <td className="px-4 py-2 border border-gray-300 text-sm">{skill.updated_on ? parseDate(skill.updated_on) : 'N/A'}</td> */}
                                                                                    </tr>
                                                                                )) || <tr><td colSpan="3" className="px-4 py-2 text-center text-sm">No skills available</td></tr>}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* Additional Details */}
                                                                    <div className="mt-4 space-y-2">
                                                                        {/* <p className="text-gray-600 text-sm"><span className="font-medium">Comments:</span> {rubric.comments || 'N/A'}</p> */}
                                                                        <p className="text-gray-600 text-sm"><span className="font-medium">Parents Suggestion:</span> {rubric.parents_suggestion || 'N/A'}</p>
                                                                        <p className="text-gray-600 text-sm">
                                                                            <span className="font-medium">Reference URL:</span>
                                                                            <a
                                                                                href={rubric.reference_url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="text-blue-500 hover:underline ml-1 print:text-black print:no-underline"
                                                                            >
                                                                                {rubric.reference_url || 'N/A'}
                                                                            </a>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))
                                            ) : (
                                                <p className="text-center text-gray-600 text-sm">No rubric data available</p>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>


                        </div>

                        //===== new report card end ========
                    )}

                    {/* =====================report card end==========================  */}


                </Sidebar>
            </div >
        </div >
    )
}

export default Students